import { ChangeDetectorRef, Component, EventEmitter, HostBinding, HostListener, OnInit, Output, TemplateRef, ViewChild, Input, DoCheck, KeyValueDiffers, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DndDropEvent, DropEffect } from 'ngx-drag-drop';
import { field, value } from '../global.model';
import { SettingService } from '../../settings/services/settingService/setting.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { FormsService } from '../services/forms.service';
import { Router } from '@angular/router';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import * as jwt_decode from 'jwt-decode';
import { AddSubFolderVM } from 'src/app/viewModels/core/add-sub-folder-vm';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { SignaturePad } from 'angular2-signaturepad';
import { ResizedEvent } from 'angular-resize-event';
import { saveAs } from 'file-saver';
import { I18nInterface } from 'ngx-image-drawing'
import { F, I } from '@angular/cdk/keycodes';
import { elementAt } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { image } from 'html2canvas/dist/types/css/types/image';
import { FormTypes, ModuleName, RoleLevel } from '../services/form.enum';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddOrgTempCategoryComponent } from 'src/app/middleware/common/addOrgTempCategory/addOrgTempCategory.component';
import { AddMasterTempCategoryComponent } from 'src/app/middleware/common/addMasterTempCategory/addMasterTempCategory.component';

@Component({
  selector: 'app-step-three',
  templateUrl: './HTMLForm.component.html',
  styleUrls: ['./HTMLForm.component.scss'],
  //host: {"(window:resize)":"onWindowResize($event)"}
})
export class HTMLFormComponent implements OnInit, DoCheck {
  public editorConfig = {
    versionCheck: false
  };
  //@ViewChild('resizable') box: ElementRef ;
  name = 'ng2-ckeditor';
  ckeConfig: any;
  ckEditorConfig: any = {
    toolbar: [
      ['Source', 'Templates', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
      ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
      ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
      ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'],
      ['Link', 'Unlink', 'Anchor'],
      ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
      ['Styles', 'Format', 'Font', 'FontSize'],
      ['TextColor', 'BGColor'],
      ['Maximize', 'ShowBlocks']
    ]
  };
  backgroundColorForm:string="#eaf1fb";
  mycontent: string;

  databaseId: string;
  organizationId: string;
  currentUser: any;
  getFieldsListResponseHolder: any;
  corefieldsList: any[] = [];
  corefieldsDragList: any[] = [];
  contactfieldsList: any[] = [];
  companyfieldsList: any[] = [];
  folderList: any[] = [];
  subFolderID: number = 0;
  participantAdded: boolean = true;
  selected3cType:boolean = false;
  openRight: boolean = false
  stepCompleted: number = 2;
  ControlForReplcaArray: any = [];
  autoFill: boolean;
  verifiedIconHasClass: any;
  multiSelectCurrentItem: any;
  dataJson: any = [];
  hTMLFormName: any = "";
  clickFormEventsubscription: any;
  currentFormName: string = '';
  hText: boolean;
  SelectedControl: any;
  TextSinglehWithFields: any = [];
  URLhWithFields: any = [];
  TrueFalseWithFields: any = [];
  FeedbackWithFields: any = [];
  RatingWithFields: any = [];
  HtmlEditorWithFields: any = [];
  ParagraphWithFields: any = [];
  MCQWithFields: any = [];
  SMCQ: boolean = false;
  STrueFalse: boolean = false;
  SRating: boolean = false;
  SFeedback: boolean = false;
  SAItext: boolean;
  showDocumentsToselectInPopup: any;
  AIDocuments: any;
  UploadedFilesDragZone: any[];
  aiDocListWithDetailForOuter: any;
  aiAnswer: any;
  selectedAIDocsOUter: any[];
  openRightPanel() {
    this.openRight = !this.openRight;
  }

  typeSelected = 1;

  iconHoder = [
    { iconName: 'align_horizontal_left', value: 1 },
    { iconName: 'align_horizontal_center', value: 2 },
    { iconName: 'align_horizontal_right', value: 3 }
  ]

  selectedIcon = this.iconHoder[0].iconName;

  width: number;
  height: number;
  cavasSize: number
  ImgWidth: number;

  @Input() imagesWithFields: any = [];
  differ: any;
  objDiffer: any;
  value: value = {
    label: "",
    value: ""
  };
  success = false;
  projectParticipantsList: any = [];
  projectDocumentsList: any = [];
  selectedParticipant: any;
  locale: string = "en";
  public i18n: I18nInterface = {
    saveBtn: "Save as image as JPEG",
    sizes: { extra: "Extra" }
  }
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  dropdownlist: any = [];
  isSelectAll: boolean = false;
  fontSize = [
    { fontsize: 7 },
    { fontsize: 8 },
    { fontsize: 9 },
    { fontsize: 10 },
    { fontsize: 11 },
    { fontsize: 12 },
    { fontsize: 14 },
    { fontsize: 16 },
    { fontsize: 18 },
    { fontsize: 20 },
    { fontsize: 22 },
    { fontsize: 24 },
    { fontsize: 26 },
    { fontsize: 28 },
    { fontsize: 36 },
    { fontsize: 48 },
    { fontsize: 72 }
  ]

  fontfamilys = [
    { font: 'Arial' },
    { font: 'Calibri' },
    { font: 'Tahoma' },
    { font: 'Verdana' },
  ]

  uploadedDocument: boolean = false;
  allParticipant: boolean = false;
  TemplateName: boolean = false;
  showToolsLeft: boolean = false;
  ShowtoolDetail: boolean = false;
  Sdropdown: boolean = false;
  SURLL: boolean = false;
  Smuldropdown: boolean = false;
  Sbutton: boolean = false;
  Stext: boolean = false;
  SButtontext: boolean = false;
  SURL: boolean = false;
  Ssingleline: boolean = false;
  SHtmlEditor: boolean = false;
  Sformat: boolean = true;
  Snumber: boolean = false;
  Sradio: boolean = false;
  Scheckbox: boolean = false;
  Scheckboxgroup: boolean = false;
  Stable: boolean = false;
  Sbullet: boolean = false;
  Sdraw: boolean = false;
  Sline: boolean = false;
  ShighLight: boolean = false;
  Sthrough: boolean = false;
  Smeasure: boolean = false;
  rotationByDegree: number = 0;
  Smultiline: boolean = false;
  Sapproval: boolean = false;
  SwhiteOut: boolean = false;
  Ssign: boolean = false;

  Ssignature: boolean = false;
  Sinitials: boolean = false;
  Sdate: boolean = false;
  Stime: boolean = false;
  Slocation: boolean = false;

  SbuttonLabel: boolean = false
  Simage: boolean = false
  Sfile: boolean = false
  coreSubFolderList: any = [] = [];
  contactSubFolderList: any = [] = [];
  companySubFolderList: any = [] = [];
  companyfieldsDragList: any[];
  contactfieldsDragList: any[];

  showSidePanel: boolean;
  clickEventsubscription: any;

  mainWithFields: any = [];
  singlLineWithFields: any = [];
  multiLineWithFields: any = [];
  numberWithFields: any = [];
  fileWithFields: any = [];
  imageWithFields: any = [];
  embedImageWithFields: any = [];
  DeviderWithFields: any = [];
  spaceWithFields: any = [];
  buttonWithFields: any = [];
  radioWithFields: any = [];
  checkboxgroupWithFields: any = [];
  dropdownWithFields: any = [];
  checkWithFields: any = [];
  bulletWithFields: any = [];
  tableWithFields: any = [];
  dateWithFields: any = [];
  strikeThroughWithFields: any = [];
  straightLineWithFields: any = [];
  MeasureWithFields: any = [];
  WhiteOutWithFields: any = [];
  HighlightFields: any = [];
  //autofill
  autofillvalues: any;
  groupRelationParticipantId: string = "";
  fieldFolders: any;
  particiantJsonListAutoFill: any = [];
  particiantJsonList: any = [];
  particiantJsonListAutoFillCore: any = [];
  waitPointer: boolean = false;
  selectedFieldToDrop: any;
  declineButtonShow: boolean = false;
  beforeFillForm: any;
  nonSelectedDocJsonList: any = [];
  openPanel: number = 0;
  IsSigningComplete: boolean = false;
  particiantJsonListAutoFillCom: any = [];
  isPageLoaded: boolean = false;
  UnChnagedparticipantJsonListArray: any = [];
  UnChnagedparticipantJsonList: any;
  SignButtonEnable: boolean = false;
  reasonToDecline: string = "";
  DrawButtonEnable: boolean = false;
  InitailButtonEnable: boolean = false;
  dialogueRef: any;
  // filenameForSign = "";
  penColor: string = "";
  particiantJsonListAutoFillBeforFill: any;
  particiantJsonListAutoFillCoreBeforFill: any;
  particiantJsonListAutoFillComBeforFill: any;
  innerhtmlvalue: string;
  initialSelectedDocumentId: any;
  openInDevice: boolean = false;
  Pagenumbers: string='';
  rows: any = [];
  column: any = [];
  selectedAIDocs: any;
  xx: number;
  yy: number;
  tblrowsnumber: any;
  tblclmnumber: any;
  tblid: any;
  tbldata: any;

  activeTab = 1;
  @Output() dateChange: EventEmitter<MatDatepickerInputEvent<any>>;

  bulletFieldArray: Array<any> = [];
  bulletFieldAttribute: any = {
    val: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    val: '',
  };

  checkboxFieldArray: Array<any> = [];
  checkboxFieldAttribute: any = {
    val: '',
  };

  checkboxGroupFieldArray: Array<any> = [];
  checkboxGroupFieldAttribute: any = {
    val: '',
  };

  radioButtonGroupFieldArray: Array<any> = [];
  radioButtonGroupFieldAttribute: any = {
    val: '',
  };

  Imageurl: any;
  text: string = "";

  ControlId: string = "";
  ControlData: any;

  isRequired: boolean = false;
  isShowListing: boolean = false;
  readonly: boolean = false;
  characterlimit: number;
  textColor: any;
  backgroundColor:any;
  fontsize: any;
  fontstyle: any;
  fontweight: any;
  textdecoration: any;
  timeWithFields: any = [];
  ApproveOrDeclineWithFields: any = [];
  fontfamily: any;
  textalign: any;
  highLightColor: any;
  brushColor: any;
  dropdownddisabled: boolean = false;
  points = [];
  signatureImage;
  signatureWithFields: any = [];
  drawWithFields: any = [];
  drawInPopUp: any = [];

  signOpt: string = 'draw';
  selected = 'option1';
  signName: string;
  selectDocumentsId:any;
  //signaturePadOptions:any;
  signaturePadOptions: any = {
    'minWidth': 2,
    'canvasWidth': 0,
    'canvasHeight': 0,
    'penColor': "#000000f2"
  };
  signatureBase64: string;
  checkboxdisabled: boolean = false;
  drawImgBase64: string;

  colorselected: any;
  colorselectedAlpha: any;
  selectedColorCode: any;
  xposition: any;
  yposition: any;

  ImageWidth: any;
  ImageHeight: any;

  tblrows: any;
  tblcoloumn: any;
  initialsWithFields: any = [];
  signOrInitialImageObj: any[];
  signInitialFontFamily: any;
  //spaceWithFields: any;
  
  link = [
    'https://fonts.googleapis.com/css2?family=Architects+Daughter&family=Caveat&family=Cookie&family=Dancing+Script&family=Great+Vibes&family=Pacifico&family=Parisienne&family=Sacramento&family=Satisfy&family=Yellowtail&display=swap',
    'https://fonts.googleapis.com/css2?family=Alex+Brush&family=Allura&family=Damion&family=Homemade+Apple&family=Leckerli+One&family=Mr+Dafoe&family=Nothing+You+Could+Do&family=Pinyon+Script&family=Tangerine&display=swap',
    'https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Grand+Hotel&family=Herr+Von+Muellerhoff&family=Italianno&family=Kristi&family=Mrs+Saint+Delafield&family=Niconne&family=Norican&family=Petit+Formal+Script&family=Rochester&display=swap',
    'https://fonts.googleapis.com/css2?family=Bilbo+Swash+Caps&family=Clicker+Script&family=Dawning+of+a+New+Day&family=Euphoria+Script&family=Ma+Shan+Zheng&family=Mr+De+Haviland&family=Qwigley&family=Sofia&family=The+Girl+Next+Door&family=Zeyada&display=swap',
    'https://fonts.googleapis.com/css2?family=Beth+Ellen&family=Charmonman&family=Devonshire&family=Dr+Sugiyama&family=Engagement&family=League+Script&family=Meie+Script&family=Mr+Bedfort&family=Romanesco&family=Stalemate&family=Zhi+Mang+Xing&display=swap'
  ];
  geolocationPosition: any;
  LocationWithFields: any = [];
  SreadOnly: boolean = false;
  Srequired: boolean;
  acceptOrdeclineText: string = 'Approve';
  controlAlignArray: any = [];
  currentPageName: string = "Page1"
  currentStep: number = 1;
  buttonText: string = 'Button';
  buttonURL: string = "";
  fillListcontrolId: any;
  participantArray: any = [];
  projectDocuments: any = [];
  projectDocumentpageImages: any = [];
  ParticipantJsonList: any = [];
  selectedDocumentId: any;
  SubmitNextButtonDisabled: boolean = false;
  changesForUndo: any = [];
  changesForRedo: any = [];
  offsetWidth: number = 0;
  offsetHeight: number = 0;
  showAllRequiredControls: boolean = false;
  indexExpanded: number;
  CompanyName: string = "";
  CoreName: string = "";
  ContactName: string = "";
  Module: string = "";
  //participantEmailId:string="";
  addfont() {
    for (var i = 0; i < this.link.length; i++) {
      const cssURL = this.link[i];
      let node = document.createElement('link');
      node.href = cssURL;
      node.rel = 'stylesheet';
      const s = document.getElementsByTagName('link')[0]
      s.parentNode.insertBefore(node, s);
    }
  }
  OfficeIDList: any = [];
  myOfficeID: any;
  showAdd3CButton: boolean = true;
  ctrlImg: any;
  rolesAsssign: any[] = [];
  
  family = [
    { font: 'Architects Daughter, cursive' },
    { font: 'Dancing Script, cursive' },
    { font: 'Pacifico, cursive' },
    { font: 'Satisfy, cursive' },
    { font: 'Caveat, cursive' },
    { font: 'Cookie, cursive' },
    { font: 'Great Vibes, cursive' },
    { font: 'Parisienne, cursive' },
    { font: 'Sacramento, cursive' },
    { font: 'Yellowtail, cursive' },
    { font: 'Alex Brush, cursive' },
    { font: 'Allura, cursive' },
    { font: 'Damion, cursive' },
    { font: 'Homemade Apple, cursive' },
    { font: 'Leckerli One, cursive' },
    { font: 'Mr Dafoe, cursive' },
    { font: 'Nothing You Could Do, cursive' },
    { font: 'Pinyon Script, cursive' },
    { font: 'Tangerine, cursive' },
    { font: 'Cedarville Cursive, cursive' },
    { font: 'Grand Hotel, cursive' },
    { font: 'Herr Von Muellerhoff, cursive' },
    { font: 'Italianno, cursive' },
    { font: 'Kristi, cursive' },
    { font: 'Niconne, cursive' },
    { font: 'Norican, cursive' },
    { font: 'Petit Formal Script, cursive' },
    { font: 'Rochester, cursive' },
    { font: 'Bilbo Swash Caps, cursive' },
    { font: 'Clicker Script, cursive' },
    { font: 'Dawning of a New Day, cursive' },
    { font: 'Euphoria Script, cursive' },
    { font: 'Ma Shan Zheng, cursive' },
    { font: 'Mr De Haviland, cursive' },
    { font: 'Qwigley, cursive' },
    { font: 'Sofia Script, cursive' },
    { font: 'The Girl Next Door, cursive' },
    { font: 'Zeyada, cursive' },
    { font: 'Beth Ellen, cursive' },
    { font: 'Charmonman, cursive' },
    { font: 'Devonshire, cursive' },
    { font: 'Dr Sugiyama, cursive' },
    { font: 'Engagement, cursive' },
    { font: 'League Script, cursive' },
    { font: 'Meie Script, cursive' },
    { font: 'Mr Bedfort, cursive' },
    { font: 'Romanesco, cursive' },
    { font: 'Stalemate, cursive' },
    { font: 'Zhi Mang Xing, cursive' },
  ]
  currentSign = {
    data: '',
    id: ''
  }
  drawnImg = {
    data: '',
    id: ''
  }

  innerWidth: number = window.innerWidth;
  innerHeight: number = window.innerHeight;
  thumbsList: any = [];
  isShiftKeyPressed: boolean = false;
  ResponseHolderDetails: any;

  FormId: number = 0;

  SaveButtonDisbled: boolean = false;
  folderLists:any=[]=[];

  constructor(private dialog: MatDialog, private settingsService: SettingService, private formsService: FormsService,
    private loaderService: LoaderService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService, private formService: FormsService,
    private router: Router, private statusConstant: StatusConstant, private _dataSharingService: DataSharingService,
    private formBuilder: FormBuilder, private cdr: ChangeDetectorRef, private addSubFolderVM: AddSubFolderVM,
    private differs: KeyValueDiffers) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    this.addfont();
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.differ = differs.find([]).create();
  }

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }


  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  saveBtn($event) {
    saveAs($event, 'image.jpg');
  }


  onWindowResize(event) {
    this.innerWidth = event.target.innerWidth;
    this.innerHeight = event.target.innerHeight;
  }

  onCkEditorReady(editor: any): boolean {
    const result = true;    
    return result;
  }

  ngOnInit(): void {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var coreName = [];
    coreName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if (coreName.length > 0) {
      this.CoreName = coreName[0].orgModuleName;
    }

    var contName = [];
    contName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if (contName.length > 0) {
      this.ContactName = contName[0].orgModuleName;
    }

    var compName = [];
    compName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Company);
    if (compName.length > 0) {
      this.CompanyName = compName[0].orgModuleName;
    }

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if(this.rolesAsssign.length > 0){      
      var admin=[];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      admin= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin
      || m.roleLevel == RoleLevel.OrganizationAdmin || m.roleLevel == RoleLevel.OfficeAdmin);
      if(admin.length > 0){
         this.showOrgnizationLevelCheckbox=true;
      }else{
        this.showOrgnizationLevelCheckbox=false;
      }
    }

    this.folderLists = JSON.parse(sessionStorage.getItem("menuModules"));  
     if(this.folderLists.length>0){
      var data= this.folderLists.filter(x => x.mainModuleName === "Core");
      this.folderId=data[0].folderID;
     }  
    if(this.folderId>0){
      this.getAllFolderFields();
    }
    this.dynamicForm = this.formBuilder.group({
      filters: this.formBuilder.array([])
    });
    this.dynamicFormParameter = this.formBuilder.group({
      filtersFormParameter: this.formBuilder.array([])
    });
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.Ssignature = true;
    this.signaturePadOptions = {
      'minWidth': 5,
      'canvasWidth': this.innerWidth,
      'canvasHeight': this.innerHeight,
      'penColor': "#000000f2"
    }


    //  this.bulletFieldArray.push(this.bulletFieldAttribute);
    this.dropdownFieldArray.push(this.dropdownFieldAttribute);
    this.checkboxFieldArray.push(this.checkboxFieldAttribute);
    this.checkboxGroupFieldArray.push(this.checkboxGroupFieldAttribute);
    //   this.radioButtonGroupFieldArray.push(this.radioButtonGroupFieldAttribute);
    this.highLightColor = this.hexToRGBA("#FFFF00", 0.2);

    this.getAllCoreFields(this.subFolderID);
    this.getAllContactFields(this.subFolderID);
    this.getAllCompanyFields(this.subFolderID);
    this.getCoreSubFolderList();
    this.getCompanySubFolderList();
    this.getContactSubFolderList();
    this.GetAIDocuments()
    this.SingleLineControl();
    this.MultiLineControl();
    this.NumberControl();
    this.FileControl();
    this.ImageControl();
    this.embedImageControl();
    this.DeviderControl();
    this.spaceControl();
    this.ButtonControl();
    this.DropDownControl();
    this.CheckBoxControl();
    this.TableListControl();
    this.CheckBoxGroupControl();
    this.DateControl();
    this.TimeControl();
    this.SignatureControl();
    this.InitialsControl();
    this.GeoLocation();
    this.ParagraphControl();
    this.TextSingleControl();
    this.URLControl();
    this.MCQControl();
    this.RatingControl();
    this.HtmlEditorControl();
    this.FeedbackControl();
    this.TrueFalseControl();
   // this.SpaceControl();
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = []
    Module = menuModulesList.filter(x => x.mainModuleName == 'Forms');
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
    }

    this.clickEventsubscription = this._dataSharingService.getClickEventforfieldsForms().subscribe(() => {
      this.getAllCoreFields(this.subFolderID);
      this.getAllContactFields(this.subFolderID);
      this.getAllCompanyFields(this.subFolderID);
    });
    this.clickFormEventsubscription = this._dataSharingService.getCurrentFormName().subscribe((val: any) => {
      if (val.trim() !== '') {
        this.currentFormName = val;
      } else {
        this.currentFormName = "";
      }
    });


    this.getStateDropdownList(231);

    if (sessionStorage.getItem('HtmlId') !== null && sessionStorage.getItem('HtmlId') !== undefined && sessionStorage.getItem('HtmlId') !== '0') {
      this.FormId = Number(sessionStorage.getItem('HtmlId'));
      this.GetHtmlForms(sessionStorage.getItem('HtmlId'));
    } else {
      this.FormId = 0;
      this.controlAlignArray = [];
      this.dataJson = [];
      this.currentFormName = "";
    }

    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    if (this.signaturePad != undefined) {
      this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
  }

  GetResponseFromAIDocOuter(qa:any) {
    this.ControlId=qa.id;
    this.ControlData={step:qa.step,pageName:qa.pageName};
    this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes( this.ControlId));
    this.text=qa.question;
    this.GetResponseFromAIDoc(
      (this.selectedAIDocs!=undefined && this.selectedAIDocs.length>0)?[{documentPath:  this.selectedAIDocs[0].documentPath}]:[]
    )
  }

  LoadSelectedAIDocs(ControlId:any){
    this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes(ControlId));
  }

  selectFilesFromDragZoneOuter(event,aicontrolIds:any="") {
    if(event.target.files.length>1){
      this.toastr.warning('Kindly upload or drag and drop only one file at a time.', '', {
        timeOut: 5000,
      });
      return;
    }
    let checkifanydocAttached= this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId) && aicontrolIds=="");
    if(checkifanydocAttached.length>0){
      this.toastr.warning('Kindly remove the document associated with the AI textbox and proceed with the upload process.', '', {
        timeOut: 5000,
      });
      return;
    }
    this.loaderService.show();
    this.formData = new FormData();
    this.UploadedFilesDragZone = [];
    this.UploadedFilesDragZone = event.target.files;
    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
        return;
      }
      var documenttype = "";
      var documentName = "";
      var FullPath = this.UploadedFilesDragZone[i].name;
      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      var documentNameSplit = newfilename.split('.');

    //  var documentNameSplit = FullPath.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];

      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      //documentName = documentName.substring(0, 30);//get first 30 chars

      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('DocumentDetails', documenttype + '|' + '0' + '|' + '1' + '|' + documentName);
    }
    this.formData.append('JSONControlID', this.ControlId);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('FormType', sessionStorage.getItem('type')); // 1 for Project and 2 for Template
    this.formData.append('FormID', sessionStorage.getItem('HtmlId'));
    let idArray=aicontrolIds.map(m => m.id);
    this.formData.append('JSONControlIDList', idArray.join(','));
    this.formService.AddAIDocuments(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (response.status == this.statusConstant.statusSuccess) {
          //this.AIDocuments=response.data;
          this.selectedAIDocsOUter=response.data;
          this.loaderService.hide();
          this.GetAIDocuments();
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }

  openAIPdfPopup(templateRef: TemplateRef<any>) {
    this.aiDocListWithDetailForOuter=[];
    this.selectedAIDocsOUter=[];
    this.controlAlignArray.forEach(element => {
      element.fields.forEach(fe => {
        if(fe.id.includes("HtmlEditor-"))
        {
            if(fe.fieldJson.aiQuestion!="" && fe.fieldJson.aiQuestion!=undefined && fe.fieldJson.aiQuestion!=null)
            this.aiDocListWithDetailForOuter.push({
                id:fe.id,
                question:fe.fieldJson.aiQuestion,
                step:element.step,
                pageName:element.pageName,
                });
           }
      });
    });
    const dialogRef = this.dialog.open(templateRef, {
       panelClass: 'custom-modalbox'
    });
  }

  hideControls(){
    let aiDocListWithDetailForOuter1=[];
    this.controlAlignArray.forEach(element => {
      element.fields.forEach(fe => {
        // write code where fe.id contains HtmlEditor-
           if(fe.id.includes("HtmlEditor-"))
           {
               aiDocListWithDetailForOuter1.push({
                id:fe.id,
                question:fe.fieldJson.aiQuestion,
                pageName:element.pageName,
                step:element.step
                });
           }
      });
    });
    aiDocListWithDetailForOuter1.forEach(element => {
      
    
    let h1= ((document.getElementById(element.id)).childNodes[0]).childNodes[2].childNodes[1].childNodes[0] as HTMLElement
         if(h1.style.display=='' || h1.style.display=='block')
         {
          h1.setAttribute('style', 'display:none');
         }
         else
         {
          h1.setAttribute('style', 'display:block');
         }

    let h2= ((document.getElementById(element.id)).childNodes[0]).childNodes[2].childNodes[1].childNodes[2] as HTMLElement
        if(h2.style.display=='' || h2.style.display=='block')
         {
          h2.setAttribute('style', 'display:none');
         }
         else
         {
          h2.setAttribute('style', 'display:block');
         }
        });
  }

  onChangeTextAIAnswer(value: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == data.step) && this.controlAlignArray.find(x => x.step == data.step).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == this.ControlId).fieldJson.selectedValue = value == undefined ? '' : value;
      //this.characterlimit;
      this.cdr.detectChanges();
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  GetResponseFromAIDoc(documents:any) {
    this.loaderService.show();
    let reqModel = {
      Question:this.text,
      docPath:documents.length>0?documents[0].documentPath:'',
      CommaSeparatedListOfPages:this.Pagenumbers,
      JSONControlID:this.ControlId,
      FormID: sessionStorage.getItem('HtmlId'),
      FormType: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
    }
    this.formService.GetResponseFromAIDoc(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if(this.aiDocListWithDetailForOuter!=undefined && this.aiDocListWithDetailForOuter.length>0) 
        {
          this.aiDocListWithDetailForOuter.find(m=>m.id==this.ControlId).isCompleted=true;
        }
        if (response.status == this.statusConstant.statusSuccess) {
          this.aiAnswer=response.data.answer;
          this.onChangeTextAIAnswer(this.aiAnswer);
          this.toastr.success('AI response fetched successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('Error Occured.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }


  ngDoCheck() {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
  }

  GetAIDocuments() {
    this.loaderService.show();
    let reqModel = {
      FormID: sessionStorage.getItem('HtmlId'),
      FormType: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
    }
    this.formService.GetAIDocuments(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (response.status == this.statusConstant.statusSuccess) {
          this.AIDocuments=response.data;
          this.loaderService.hide();
          
          // this.toastr.success('File uploaded successfully.', '', {
          //   timeOut: 3000,
          // });
        }
        else {
          this.toastr.error('Error Occured.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }

  fetchLocation(data, id) {
    if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        position => {
          this.geolocationPosition = position;
          if (this.controlAlignArray.find(x => x.step == data.step)) {
            this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.Lat = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.latitude : '';
            this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.Long = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.longitude : '';
          }
          if (this.dataJson.find(x => x.id == id)) {
            this.dataJson.find(x => x.id == id).value = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.latitude : '';
            this.dataJson.find(x => x.id == id).ctrlType = 'Location';
          }
        },
        error => {
          switch (error.code) {
            case 1:
              break;
            case 2:
              break;
            case 3:
              break;
          }
        }
      );
    };
  }


  onChangeCkEditor(event: any, data, item): void {
     this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = event == undefined ? '' : event;
    //this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fieldName = value == undefined ? '' : value;
    // this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == data.id).selectedValue = value == undefined ? '' : value;
  }

  SaveSign(data) {
    this.signatureImage = data;
  }

  MapDocToControls(doc) {
    let checkifanydocAttached= this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
     if(checkifanydocAttached.length>0){
       this.toastr.warning('Kindly clear the current document mapped to the AI textbox and try mapping again', '', {
         timeOut: 5000,
       });
       return;
     }
     this.loaderService.show();
     this.formData = new FormData();
     this.formData.append('JSONControlID', this.ControlId);
     this.formData.append('UserID', this.currentUser.UID);
     this.formData.append('OrganizationID', this.organizationId);
     this.formData.append('OfficeID', this.myOfficeID);
     this.formData.append('DatabaseID', this.databaseId);
     this.formData.append('FormType', sessionStorage.getItem('type')); // 1 for Project and 2 for Template
     this.formData.append('FormID', sessionStorage.getItem('HtmlId'));
     this.formData.append('DocumentID', doc.documentID);
     this.formService.AddAIDocuments(this.formData).subscribe((response) => {
       if (response != undefined) {
         this.loaderService.hide();
         if (response.status == this.statusConstant.statusSuccess) {
           this.AIDocuments=response.data;
           this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
           this.showDocumentsToselectInPopup=this.AIDocuments.filter(m=>!this.selectedAIDocs.find(n=>n.documentID==m.documentID));
           this.loaderService.hide();
           
           this.toastr.success('Document selected successfully.', '', {
             timeOut: 3000,
           });
         }
         else {
           this.toastr.error('File Upload failed.', '', {
             timeOut: 3000,
           });
           this.UploadedFilesDragZone = [];
           this.loaderService.hide();
         }
       } else {
         this.UploadedFilesDragZone = [];
         this.loaderService.hide();
       }
     });
   }

  DeleteAIDocuments(document:any) {
    this.loaderService.show();
    let reqModel = {
      DocumentID:document.documentID,
      JSONControlID:this.ControlId,
      FormID: sessionStorage.getItem('HtmlId'),
      FormType: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
    }
    this.formService.DeleteAIDocuments(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (response.status == this.statusConstant.statusSuccess) {
          this.AIDocuments=response.data;
          this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
          this.showDocumentsToselectInPopup=this.AIDocuments.filter(m=>!this.selectedAIDocs.find(n=>n.documentID==m.documentID));
          this.loaderService.hide();
          
          this.toastr.success('Document unmapped successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('Error Occured.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        //this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }

  selectDocuments(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.showDocumentsToselectInPopup=this.AIDocuments.filter(m=>!this.selectedAIDocs.find(n=>n.documentID==m.documentID))
  }

  formData: FormData;

  selectFilesFromDragZone(event) {
    if(event.target.files.length>1){
      this.toastr.warning('Kindly upload or drag and drop only one file at a time.', '', {
        timeOut: 5000,
      });
      return;
    }
    let checkifanydocAttached= this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
    if(checkifanydocAttached.length>0)
    {
      this.toastr.warning('Kindly remove the document associated with the AI textbox and proceed with the upload process.', '', {
        timeOut: 5000,
      });
      return;
    }
    this.loaderService.show();
    this.formData = new FormData();
    this.UploadedFilesDragZone = [];
    this.UploadedFilesDragZone = event.target.files;
    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
        return;
      }
      var documenttype = "";
      var documentName = "";
      var FullPath = this.UploadedFilesDragZone[i].name;
      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      var documentNameSplit = newfilename.split('.');

     // var documentNameSplit = FullPath.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];

      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      //documentName = documentName.substring(0, 30);//get first 30 chars

      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('DocumentDetails', documenttype + '|' + '0' + '|' + '1' + '|' + documentName);
    }
    this.formData.append('JSONControlID', this.ControlId);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('FormType', sessionStorage.getItem('type')); // 1 for Project and 2 for Template
    this.formData.append('FormID', sessionStorage.getItem('HtmlId'));
    this.formService.AddAIDocuments(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (response.status == this.statusConstant.statusSuccess) {
          this.AIDocuments=response.data;
          this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
          this.loaderService.hide();
          
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }

  OpenSignPopup(templateRef: TemplateRef<any>, data: any, item: any, event: any) {
    this.ControlData = data;
    this.ControlId = item.id;
    this.SignButtonEnable = false;
    this.InitailButtonEnable = false;
    if (this.ControlId == undefined) {
      this.ControlId = item;
    }
    this.filenameForSign = "";

    this.currentSign.data = data;
    this.currentSign.id = item.id;

    this.signName = "";
    this.selected = ''
    this.signOpt = 'draw';
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });

    if (this.controlAlignArray.find(x => x.step == data.step)) {
      // this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
      //   if (element.id != item.id)
      //     element.ShowtoolDetail = false;
      // });

      var FieldsDetails = this.controlAlignArray.find(x => x.step == data.step);
      var getData = FieldsDetails.fields.find(x => x.id === item.id).fieldJson;
      if (getData != null && getData != undefined) {
        this.ControlData = FieldsDetails;
        this.ControlId = item.id;
        this.isRequired = getData.isRequired;
        if (getData.isShowListing == null || getData.isShowListing == undefined) {
          this.isShowListing = false;
        } else {
          this.isShowListing = getData.isShowListing;
        }
        this.readonly = getData.readonly;
        if (getData.brushColor != undefined)
          this.brushColor = getData.brushColor;
      }
      var penColor = "";
      this.brushColor;
      if (getData.penColor == "" || getData.penColor == undefined) {
        this.penColor = "#000000f2";
      } else {
        this.penColor = this.brushColor;//item.penColor;
      }

      this.imgDrawStart();

      var sigContainer = document.querySelector(".allSCont") as HTMLElement;
      this.signaturePadOptions = {
        'minWidth': 5,
        'canvasWidth': sigContainer.clientWidth,
        'canvasHeight': sigContainer.clientHeight,
        'penColor': this.penColor//"#000000f2"
      }
    }
  }


  OpenDrawPopup(templateRef: TemplateRef<any>, data: any, field: any, id: any) {
    this.drawnImg.data = data;
    this.drawnImg.id = id;
    this.DrawButtonEnable = false;
    this.dialogueRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });

    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
        if (element.id != id)
          element.ShowtoolDetail = false;
      });
      field.ShowtoolDetail = true;
      var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id === id);
      if (getData.length > 0) {
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        if (getData[0].isShowListing == null || getData[0].isShowListing == undefined) {
          this.isShowListing = false;
        } else {
          this.isShowListing = getData[0].isShowListing;
        }
        this.readonly = getData[0].readonly;
        if (getData[0].brushColor != undefined)
          this.brushColor = getData[0].brushColor;
      }
      if (field.penColor == "" || field.penColor == undefined) {
        this.penColor = "#000000f2";
      } else {
        this.penColor = field.penColor;
      }
      var sigContainer = document.querySelector(".allSCont") as HTMLElement;
      this.signaturePadOptions = {
        'minWidth': 3,
        'canvasWidth': sigContainer.clientWidth,
        'canvasHeight': sigContainer.clientHeight,
        'penColor': this.penColor//"#000000f2"
      }
    }
  }

  OpenDrawInPopup(templateRef: TemplateRef<any>, data: any, id: any) {
    // this.drawnImg.data=data;
    // this.drawnImg.id=id;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

 

  clearSignature() {
    this.SignButtonEnable = false;
    this.signaturePad.clear();
  }

  drawComplete() {
    this.SignButtonEnable = true;
    this.DrawButtonEnable = true;
    this.InitailButtonEnable = true;
    // will be notified of szimek/signature_pad's onEnd event    
    //let canvas = document.getElementsByTagName("canvas")[0]; 
    // this.signatureBase64=canvas.toDataURL();
  }


  addSignature() {
    let data: any = this.ControlData;
    let canvas = document.getElementsByTagName("canvas")[0];
    if (canvas != undefined) {
      this.signatureBase64 = canvas.toDataURL();
      this.signName = "";
      this.signOrInitialImageObj = [];
    }
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureBase64 = this.signatureBase64;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signatureText = this.signName;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.signInitialFontFamily = this.signInitialFontFamily;
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.ImageData = this.signOrInitialImageObj;
    }
    if (this.dataJson.find(x => x.id == this.ControlId)) {
      if (this.signatureBase64 != '') {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signatureBase64;
        this.dataJson.find(x => x.id == this.ControlId).type = 'image';
      }
      else if (this.signName != '') {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signName;
        this.dataJson.find(x => x.id == this.ControlId).type = 'text';
        this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
      }
      else {
        this.dataJson.find(x => x.id == this.ControlId).value = this.signOrInitialImageObj[0].Imageurl;
        this.dataJson.find(x => x.id == this.ControlId).type = 'image';
        this.dataJson.find(x => x.id == this.ControlId).signInitialFontFamily = '';
      }
    }
    this.dialog.closeAll();
  }

  addDrawnImg() {
    let data: any = this.drawnImg.data;
    let canvas = document.getElementsByTagName("canvas")[0];
    if (canvas != undefined)
      this.drawImgBase64 = canvas.toDataURL();
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).drawBase64 = this.drawImgBase64;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).brushColor = this.brushColor;

      this.imagesWithFields = this.imagesWithFields;
    }
    this.dialog.closeAll();
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event
  }

  imgDrawStart() {
    if (this.brushColor != "")
      this.signaturePadOptions.penColor = "RGB(" + this.hexToRGBA(this.brushColor, 1) + ")";
    else {
      this.brushColor = "#000000";
      this.signaturePadOptions.penColor = "RGB(" + this.hexToRGBA(this.brushColor, 1) + ")";
    }
  }


  SingleLineControl() {
    this.singlLineWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Single-Line",
        "placeholderName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Textbox",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }



  MultiLineControl() {
    this.multiLineWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Multi-Line",
        "placeholderName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Textarea",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  NumberControl() {
    this.numberWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Number",
        "placeholderName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Number",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  FileControl() {
    this.fileWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "File",
        "placeholderName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "File",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }


  ButtonControl() {
    this.buttonWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Button",
        "placeholderName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Button",
        "placeholder": "",
        "defaultValue": "Button",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": "Button",
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "#03a9f4",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  embedImageControl() {
    this.embedImageWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Embed Image",
        "placeholderName": "embedImage",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "embedImage",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  ImageControl() {
    this.imageWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Image",
        "placeholderName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Image",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  spaceControl() {
    this.spaceWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Space",
        "labelName": "Space",
        "placeholderName": "Space",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Space",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": true,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0,
        "topMargin": ""
      })
  }

  DeviderControl() {
    this.DeviderWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Devider",
        "labelName": "Devider",
        "placeholderName": "Devider",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Devider",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": true,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  TextSingleControl() {
    this.TextSinglehWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "TextSingle",
        "placeholderName": "TextSingle",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "TextSingle",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": true,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  URLControl() {
    this.URLhWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "URL",
        "placeholderName": "URL",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "URL",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  TrueFalseControl() {
    this.TrueFalseWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "TrueFalse",
        "labelName": "TrueFalse",
        "placeholderName": "TrueFalse",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "TrueFalse",
        "placeholder": "",
        "defaultValue": "",
        "fillList": ["True", "False"],
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  HtmlEditorControl() {
    this.HtmlEditorWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "HtmlEditor",
        "labelName": "HtmlEditor",
        "placeholderName": "Html Editor",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "HtmlEditor",
        "placeholder": "",
        "defaultValue": "",
        "fillList": [
        ],
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  RatingControl() {
    this.RatingWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Rating",
        "labelName": "Rating",
        "placeholderName": "Rating",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Rating",
        "placeholder": "",
        "defaultValue": "",
        "fillList": [{
          id: 1,
          val: "Worst",
          active: false
        },
        {
          id: 2,
          val: "Bad",
          active: false
        },
        {
          id: 3,
          val: "Good",
          active: false
        },
        {
          id: 4,
          val: "Very Good",
          active: false
        }, {
          id: 5,
          val: "Excellent",
          active: false
        }

        ],
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  FeedbackControl() {
    this.FeedbackWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Feedback",
        "labelName": "Feedback",
        "placeholderName": "Feedback",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Feedback",
        "placeholder": "",
        "defaultValue": "",
        "fillList": [{
          id: 1,
          val: "Strongly Disagree",
          active: false
        },
        {
          id: 2,
          val: "Disagree",
          active: false
        },
        {
          id: 3,
          val: "Somewhat Disagree",
          active: false
        },
        {
          id: 4,
          val: "Somewhat Agree",
          active: false
        }, {
          id: 5,
          val: "Agree",
          active: false
        }, {
          id: 6,
          val: "Strongly Agree",
          active: false
        }

        ],
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  ParagraphControl() {
    this.ParagraphWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Paragraph",
        "placeholderName": "Paragraph",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Paragraph",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": true,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  MCQControl() {
    this.MCQWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "MCQ",
        "labelName": "MCQ",
        "placeholderName": "MCQ",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "MCQ",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "radioSelectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  CheckBoxGroupControl() {
    this.checkboxgroupWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Checkbox",
        "labelName": "Checkbox",
        "placeholderName": "Checkbox",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "CheckBoxGroup",
        "placeholder": "",
        "defaultValue": "'',''",//"Option 1,Option 2",      
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  DropDownControl() {
    this.dropdownWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "DropDown",
        "labelName": "DropDown",
        "placeholderName": "DropDown",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Dropdown",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  CheckBoxControl() {
    this.checkWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Checkbox",
        "labelName": "Checkbox",
        "placeholderName": "Checkbox",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Checkbox",
        "placeholder": "",
        "defaultValue": "",//"Option 1,Option 2",      
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }


  TableListControl() {
    this.tableWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Table",
        "labelName": "Table",
        "placeholderName": "Table",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Table",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  DateControl() {
    this.dateWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Date",
        "placeholderName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Date",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  TimeControl() {
    this.timeWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "labelName": "Time",
        "placeholderName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Time",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }



  GeoLocation() {
    this.LocationWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Location",
        "labelName": "Location",
        "placeholderName": "Location",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Location",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  SignatureControl() {
    this.signatureWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Signature",
        "labelName": "Signature",
        "placeholderName": "Signature",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Signature",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  InitialsControl() {
    this.initialsWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Initials",
        "labelName": "Initials",
        "placeholderName": "Initials",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Initials",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": 0,
        "column": 0,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": false,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  // SpaceControl() {
  //   this.spaceWithFields.push(
  //     {
  //       "id": "",
  //       "fieldID": 0,
  //       "fieldName": "Initials",
  //       "labelName": "Initials",
  //       "placeholderName": "Initials",
  //       "folderID": 0,
  //       "folderName": "",
  //       "fieldTypeID": 0,
  //       "fieldTypeName": "Initials",
  //       "placeholder": "",
  //       "defaultValue": "",
  //       "fillList": "",
  //       "FileData": [],
  //       "ImageData": [],
  //       "rows": 0,
  //       "column": 0,
  //       "selectedValue": '',
  //       "isRequired": false,
  //       "isShowListing": false,
  //       "readonly": false,
  //       "charLimit": "40",
  //       "fontSize": "14px",
  //       "fontName": "",
  //       "fontstyle": "",
  //       "fontweight": "",
  //       "textdecoration": "",
  //       "fontColor": "",
  //       "fontfamily": "Arial",
  //       "offsetX": "",
  //       "offsetY": "",
  //       "height": 0,
  //       "width": 0,
  //       "textalign": "",
  //       "chkSelectedValues": [],
  //       "rbSelectedValues": "",
  //       "fieldNames": "",
  //       "buttonText": "",
  //       "signatureBase64": "",
  //       "signatureText": '',
  //       "drawBase64": "",
  //       "colorCode": "",
  //       "colorCodeAlpha": "",
  //       'signInitialFontFamily': '',
  //       'Lat': '',
  //       'Long': '',
  //       "selectedParticipant": "",
  //       "backgroundColor": "",
  //       "buttonName": "",
  //       "buttonURL": "",
  //       "brushColor": undefined,
  //       "rotation": 0
  //     })
  // }
  HeaderTextChanges(item) {

    let size = this.HeaderFooter.find(x => x.type == 'Header').fontSize;
    if (size !== undefined && size !== "") {
      size = this.HeaderFooter.find(x => x.type == 'Header').fontSize.substr(0, this.HeaderFooter.find(x => x.type == 'Header').fontSize.length - 2);
      this.fontsize = Number(size);
    }
    else{
     this.fontsize = 14;
    }     

    this.textColor = this.HeaderFooter.find(x => x.type == 'Header').color;
    if (this.textColor == undefined || this.textColor == ""){
      this.textColor = 'rgb(19, 16, 16)';
    }    

    this.fontfamily = this.HeaderFooter.find(x => x.type == 'Header').fontfamily;
    if (this.fontfamily == undefined || this.fontfamily == ""){
     this.fontfamily = 'Arial';
    }
    
    this.hText = true;
    this.ShowtoolDetail = true;
    this.showToolsLeft = false;
    this.Sdropdown = false;
    this.Smuldropdown = false;
    this.Sbutton = false;
    this.Snumber = false;
    this.Sradio = false;
    this.Scheckbox = false;
    this.Scheckboxgroup = false;
    this.Stable = false;
    this.Sbullet = false;
    this.Sformat = true;
    this.Sdraw = false;
    this.Stext = false;
    this.SButtontext = false;
    this.SURL = false;
    this.Smeasure = false;
    this.Sline = false;
    this.Smultiline = false;
    this.Ssingleline = false;
    this.Sthrough = false;
    this.SwhiteOut = false;
    this.ShighLight = false;
    this.Ssignature = false;
    this.Sinitials = false;
    this.Sapproval = false;
    this.Sdate = false;
    this.Stime = false;
    this.Slocation = false;

    this.SbuttonLabel = false;
    this.Simage = false;
    this.Sfile = false;
    this.SURLL = false;
  }

  spaceBar = false;

  OpentoolDetail(message: any) {
    this.SelectedControl = message;
    if (this.isShiftKeyPressed) {
      this.ShowtoolDetail = false;
      this.isShiftKeyPressed = false;
    }
    else {
      this.ShowtoolDetail = true;
      if (message != 'Dropdown') {
        // this.controlAlignArray=[];
      }
    }

    this.makeControlDetailHeadingFalse()
    
    this.backgroundColorshow=false;
    if (message == 'Devider') {
      this.isShowListing = true;
      this.Ssingleline = true;
      this.Stext = true;
      this.Sformat = true;
    }
    if (message == 'Space') {
      this.isShowListing = true;
      //this.Ssingleline = true;
      this.Stext = true;
      this.Sformat = true;
      this.spaceBar= true;
    }
    if (message == 'TextSingle') {
      this.isShowListing = true;
      this.Ssingleline = true;
      this.Stext = true;
      this.Sformat = true;
    }
    if (message == 'HtmlEditor') {
      this.SHtmlEditor = true;
      this.Stext = true;
      this.SAItext=true
      // this.Sformat = true;
    }
    if (message == 'URL') {
      this.isShowListing = true;
      this.Ssingleline = true;
      this.Stext = true;
    }
    if (message == 'Paragraph') {
      this.isShowListing = true;
      this.Ssingleline = true;
      this.Stext = true;
      this.Sformat = true;
    }
    if (message == 'Signature') {
      this.Ssignature = true;
    }

    if (message == 'Initials') {
      this.Sinitials = true;
    }

    if (message == 'File') {
      this.Sfile = true;
    }

    if (message == 'Image') {
      this.Simage = true;
    }

    if (message == 'embedImage') {
      this.Simage = true;
    }

    if (message == 'Location') {
      this.Slocation = true;
      this.Sformat = true;
    }

    if (message == 'Time') {
      this.Stime = true;
      this.Sformat = true;
    }

    if (message == 'Date') {
      this.Sdate = true;
      this.Sformat = true;
    }

    if (message == 'ApproveOrDecline') {
      this.Sapproval = true;
      this.SreadOnly = false;
      // this.Srequired = true;
      this.Sbutton = true;
      this.Sformat = true;
    }

    if (message == 'Textbox') {
      this.Ssingleline = true;
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'BulletList') {
      this.Sformat = true;
      this.Sbullet = true;
    }

    if (message == 'Textarea') {
      this.Smultiline = true;
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'Date') {
      this.Sformat = true;
    }

    if (message == 'line' || message == 'StraightLine') {
      this.Sline = true;
    }

    if (message == 'measure') {
      this.Smeasure = true;
    }

    if (message == 'Draw') {
      this.Sdraw = true;
    }


    if (message == 'format') {
      this.Sformat = true;
    }

    if (message == 'Table') {
      this.Stable = true;
      this.Stext = false;
    }

    if (message == 'text') {
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'Radio') {
      this.Sradio = true;
      this.Sformat = true;
    }

    if (message == 'Checkbox') {
      this.Scheckbox = true;
      this.Sformat = true;
    }

    if (message == 'CheckBoxGroup') {
      this.Scheckboxgroup = true;
      this.Sformat = true;
    }

    if (message == 'MultiSelect') {
      this.Smuldropdown = true;
      this.Sformat = true;
    }

    if (message == 'Dropdown') {
      this.Sdropdown = true;
      this.Sformat = true;
    }
    if (message == 'MCQ') {
      this.SMCQ = true;
      this.Sformat = true;
      this.Stext = true;
      //this.Ssingleline = true;
    }
    if (message == 'TrueFalse') {
      this.STrueFalse = true;
      this.Sformat = true;
      this.Stext = true;
      //this.Ssingleline = true;
    }
    if (message == 'Rating') {
      this.SRating = true;
      this.Sformat = true;
      this.Stext = true;
      //this.Ssingleline = true;
    }
    if (message == 'Feedback') {
      this.SRating = true;
      this.Sformat = true;
      this.Stext = true;
      //this.Ssingleline = true;
    }
    if (message == 'Button') {
      this.SbuttonLabel = true;
      this.SButtontext = true;
      this.SURL = true;
      this.Sformat = true;
      this.backgroundColorshow=true;
    }

    if (message == 'Number') {
      this.Snumber = true;
      this.Sformat = true;
    }
    if (message == 'StrikeThrough') {
      this.Sthrough = true;
    }
    if (message == "WhiteOut") {
      this.SwhiteOut = true;
    }

    if (message == "HighLight") {
      this.ShighLight = true;
    }
    // if (message == "URL") {
    //   this.SURLL = true;
    //   this.Sformat = true;
    // }

  }


  makeControlDetailHeadingFalse(){
    this.hText = false;
    //!this.ShowtoolDetail
    this.showToolsLeft = false;
    this.Sdropdown = false;
    this.Smuldropdown = false;
    this.Sbutton = false;
    this.Snumber = false;
    this.Sradio = false;
    this.Scheckbox = false;
    this.Scheckboxgroup = false;
    this.Stable = false;
    this.Sbullet = false;
    this.Sformat = false;
    this.Sdraw = false;
    this.Stext = false;
    this.SButtontext = false;
    this.SURL = false;
    this.Smeasure = false;
    this.Sline = false;
    this.Smultiline = false;
    this.Ssingleline = false;
    this.Sthrough = false;
    this.SwhiteOut = false;
    this.ShighLight = false;
    this.Ssignature = false;
    this.Sinitials = false;
    this.Sapproval = false;
    this.Sdate = false;
    this.Stime = false;
    this.Slocation = false;
    this.SAItext=false
    this.SbuttonLabel = false;
    this.Simage = false;
    this.Sfile = false;
    this.SURLL = false;
    this.SMCQ = false;
    this.SHtmlEditor = false;
  }

onEditorClick(item: any): void {
  this.LoadSelectedAIDocs(item.id);
  this.OpentoolDetail('HtmlEditor');
}


  createField(value: any) {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    if (value == "Core") {
      var data = [];
      data = menuModulesList.filter(x => x.mainModuleName === "Core");
      if (data.length > 0) {
        var folderId = data[0].folderID;
      }
    }
    if (value == "Contact") {
      var data = [];
      data = menuModulesList.filter(x => x.mainModuleName === "Contact");
      if (data.length > 0) {
        var folderId = data[0].folderID;
      }
      // var data = this.folderList.filter(x => x.folderName === "Contact");
      // var folderId = data[0].folderID;
    }
    if (value == "Company") {
      var data = [];
      data = menuModulesList.filter(x => x.mainModuleName === "Company");
      if (data.length > 0) {
        var folderId = data[0].folderID;
      }
      //var data = this.folderList.filter(x => x.folderName === "Company");
      // var folderId = data[0].folderID;
    }
    this.showSidePanel = true;
    this._dataSharingService.sendSelectedFolderIdInSetting(folderId);
  }

  OnAcceptOrDecline(e: any, isAccecpt: boolean) {
    let ctrl = this.ControlData;
    let ctrlId = this.ControlId;

    if (this.imagesWithFields.find(x => x.img == ctrl.img) && this.imagesWithFields.find(x => x.img == ctrl.img).fields.length > 0) {
      if (isAccecpt) {
        this.imagesWithFields.find(x => x.img == ctrl.img).fields.find(m => m.id == ctrlId).buttonText = 'Approve';
        this.acceptOrdeclineText = 'Approve';
      } else {
        this.imagesWithFields.find(x => x.img == ctrl.img).fields.find(m => m.id == ctrlId).buttonText = 'Decline';
        this.acceptOrdeclineText = 'Decline';
      }
    }
  }

  closecreateField(message: boolean) {
    this.showSidePanel = false;
  }

  getAllCoreFields(subFolderID) {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Core");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          var corefieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          corefieldsListData = corefieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.corefieldsList = corefieldsListData.filter((s) => s.availableOn != 1);
          var FieldsListData = this.corefieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              //  List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.corefieldsList.push(req);
              }
            }
          }
          this.corefieldsList = this.corefieldsList.filter((s) => s.fieldID != 0);
          this.corefieldsDragList = this.corefieldsList;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getAllCoreSubfolderFields(subFolderID) {
    // var data = this.folderList.filter(x => x.folderName === "Core");
    // var folderId = data[0].folderID;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Core");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    let SubFolderName = this.coreSubFolderList.find(x => x.subFolderID == subFolderID).folderName;
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          let corefieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          corefieldsListData = corefieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.corefieldsList = corefieldsListData.filter((s) => s.availableOn != 1);
          let FieldsListData = this.corefieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          //var FieldsListData = this.corefieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);
          // let corefieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // corefieldsListData = corefieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.corefieldsList = corefieldsListData.filter((s) => s.availableOn != 1);
          // let FieldsListData = this.corefieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              // List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.corefieldsList.push(req);
              }
            }
          }
          this.corefieldsList = this.corefieldsList.filter((s) => s.fieldID != 0);
          this.corefieldsList.map(function (entry) {
            entry["subFolderName"] = SubFolderName;
          });
          this.corefieldsDragList = this.corefieldsList;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getAllCompanySubfolderFields(subFolderID) {
    // var data = this.folderList.filter(x => x.folderName === "Company");
    // var folderId = data[0].folderID;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Company");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    let SubFolderName = this.companySubFolderList.find(x => x.subFolderID == subFolderID).folderName;
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          // var companyfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // companyfieldsListData = companyfieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.companyfieldsList = companyfieldsListData;//corefieldsListData.filter((s) => s.availableOn != 1);
          // var FieldsListData = this.companyfieldsList.filter((s) => s.fieldID == 0);
          let companyfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          companyfieldsListData = companyfieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.companyfieldsList = companyfieldsListData.filter((s) => s.availableOn != 1);
          let FieldsListData = this.companyfieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              // List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.companyfieldsList.push(req);
              }
            }
          }

          this.companyfieldsList.map(function (entry) {
            entry["subFolderName"] = SubFolderName;
          });
          this.companyfieldsList = this.companyfieldsList.filter((s) => s.fieldID != 0);
          this.companyfieldsDragList = this.companyfieldsList;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getAllContactSubfolderFields(subFolderID) {
    //var data = this.folderList.filter(x => x.folderName === "Contact");
    //var folderId = data[0].folderID;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Contact");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    let SubFolderName = this.contactSubFolderList.find(x => x.subFolderID == subFolderID).folderName;
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          // var contactfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // contactfieldsListData = contactfieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.contactfieldsList = contactfieldsListData;//corefieldsListData.filter((s) => s.availableOn != 1);
          // var FieldsListData = this.contactfieldsList.filter((s) => s.fieldID == 0);
          let contactfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          contactfieldsListData = contactfieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.contactfieldsList = contactfieldsListData.filter((s) => s.availableOn != 1);
          let FieldsListData = this.contactfieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              // List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.contactfieldsList.push(req);
              }
            }
          }

          this.contactfieldsList.map(function (entry) {
            entry["subFolderName"] = SubFolderName;
          });
          // this.contactfieldsList.map
          this.contactfieldsList = this.contactfieldsList.filter((s) => s.fieldID != 0);
          this.contactfieldsDragList = this.contactfieldsList;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getCoreSubFolderList() {
    //var data = this.folderList.filter(x => x.folderName === "Core");
    // let folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Core");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    this.addSubFolderVM.folderID = folderId;
    this.addSubFolderVM.userID = this.currentUser.UID;
    this.addSubFolderVM.databaseID = Number(this.databaseId);
    this.addSubFolderVM.organizationId = Number(this.organizationId);
    this.addSubFolderVM.officeID = this.myOfficeID;
    this.addSubFolderVM.OfficeIDList = this.OfficeIDList;
    this.settingsService.getSubFolderList(this.addSubFolderVM).subscribe(response => {
      if (response != undefined) {
        let getSubFolderListResponseHolder: any;
        getSubFolderListResponseHolder = response;
        if (getSubFolderListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.coreSubFolderList = getSubFolderListResponseHolder.data;
          if (this.coreSubFolderList.length > 0) {
            this.coreSubFolderList = getSubFolderListResponseHolder.data.filter(x => x.isActive == true);
          }
          // if (this.coreSubFolderList) {
          //   this.coreSubFolderList.forEach(e => {
          //     if (e.isActive) {
          //       e.folderName = e.folderName + ' (Active)';
          //     } else {
          //       e.folderName = e.folderName + ' (InActive)';
          //     }
          //   });
          // }
        }
      }
    });
  }

  getContactSubFolderList() {
    // var data = this.folderList.filter(x => x.folderName === "Contact");
    // let folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Contact");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    this.addSubFolderVM.folderID = folderId;
    this.addSubFolderVM.userID = this.currentUser.UID;
    this.addSubFolderVM.databaseID = Number(this.databaseId);
    this.addSubFolderVM.organizationId = Number(this.organizationId);
    this.addSubFolderVM.officeID = this.myOfficeID;
    this.addSubFolderVM.OfficeIDList = this.OfficeIDList;
    this.settingsService.getSubFolderList(this.addSubFolderVM).subscribe(response => {
      if (response != undefined) {
        let getSubFolderListResponseHolder: any;
        getSubFolderListResponseHolder = response;
        if (getSubFolderListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.contactSubFolderList = getSubFolderListResponseHolder.data;
          if (this.contactSubFolderList.length > 0) {
            this.contactSubFolderList = getSubFolderListResponseHolder.data.filter(x => x.isActive == true);
          }
          // if (this.contactSubFolderList) {
          //   this.contactSubFolderList.forEach(e => {
          //     if (e.isActive) {
          //       e.folderName = e.folderName + ' (Active)';
          //     } else {
          //       e.folderName = e.folderName + ' (InActive)';
          //     }
          //   });
          // }
        }
      }
    });
  }

  getCompanySubFolderList() {
    // var data = this.folderList.filter(x => x.folderName === "Company");
    // let folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Company");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    this.addSubFolderVM.folderID = folderId;
    this.addSubFolderVM.userID = this.currentUser.UID;
    this.addSubFolderVM.databaseID = Number(this.databaseId);
    this.addSubFolderVM.organizationId = Number(this.organizationId);
    this.addSubFolderVM.officeID = this.myOfficeID;
    this.addSubFolderVM.OfficeIDList = this.OfficeIDList;
    this.settingsService.getSubFolderList(this.addSubFolderVM).subscribe(response => {
      if (response != undefined) {
        let getSubFolderListResponseHolder: any;
        getSubFolderListResponseHolder = response;
        if (getSubFolderListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.companySubFolderList = getSubFolderListResponseHolder.data;
          if (this.companySubFolderList.length > 0) {
            this.companySubFolderList = getSubFolderListResponseHolder.data.filter(x => x.isActive == true);
          }
          // if (this.companySubFolderList) {
          //   this.companySubFolderList.forEach(e => {
          //     if (e.isActive) {
          //       e.folderName = e.folderName + ' (Active)';
          //     } else {
          //       e.folderName = e.folderName + ' (InActive)';
          //     }
          //   });
          // }
        }
      }
    });
  }

  getAllCompanyFields(subFolderID) {
    //  var data = this.folderList.filter(x => x.folderName === "Company");
    // var folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Company");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          // var companyfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // companyfieldsListData = companyfieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.companyfieldsList = companyfieldsListData;//corefieldsListData.filter((s) => s.availableOn != 1);
          // var FieldsListData = this.companyfieldsList.filter((s) => s.fieldID == 0);
          var companyfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          companyfieldsListData = companyfieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.companyfieldsList = companyfieldsListData.filter((s) => s.availableOn != 1);
          var FieldsListData = this.companyfieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              //List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.companyfieldsList.push(req);
              }
            }
          }
          this.companyfieldsList = this.companyfieldsList.filter((s) => s.fieldID != 0);
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getAllContactFields(subFolderID) {
    // var data = this.folderList.filter(x => x.folderName === "Contact");
    // var folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Contact");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          // var contactfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // contactfieldsListData = contactfieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.contactfieldsList = contactfieldsListData;//corefieldsListData.filter((s) => s.availableOn != 1);
          // var FieldsListData = this.contactfieldsList.filter((s) => s.fieldID == 0);
          var contactfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          contactfieldsListData = contactfieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.contactfieldsList = contactfieldsListData.filter((s) => s.availableOn != 1);
          var FieldsListData = this.contactfieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              // List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.contactfieldsList.push(req);
              }
            }
          }
          this.contactfieldsList = this.contactfieldsList.filter((s) => s.fieldID != 0);
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  onDragStart(event: DragEvent) {
  }

  onDragEnd(event: DragEvent) {

  }

  onDraggableCopied(event: DragEvent) {

  }

  onDraggableLinked(event: DragEvent) {

  }

  onDragged(item: any, list: any[], effect: DropEffect) {
    if (effect === "move") {
      const index = list.indexOf(item);
      list.splice(index, 1);
    }
  }


  onDragCanceled(event: DragEvent) {
  }

  onDragover(event: DragEvent) {
  }

  onChangeTextAIQestion(value: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == data.step) && this.controlAlignArray.find(x => x.step == data.step).fields.length > 0) {
      //this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == this.ControlId).fieldJson.aiQuestion = value == undefined ? '' : value;
      //this.characterlimit;
      this.cdr.detectChanges();
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onChanges(value: any, step: any, item: any) {
    this.text = value;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = value == undefined ? '' : value;
    //this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fieldName = value == undefined ? '' : value;
    // this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == data.id).selectedValue = value == undefined ? '' : value;
    if (this.SelectedControl == "MCQ" || this.SelectedControl == "TrueFalse" || this.SelectedControl == "Rating" || this.SelectedControl == "Feedback") {

      this.dataJson.find(x => x.id == item.id).name = value;
    }
    else {
      this.dataJson.find(x => x.id == item.id).value = value == undefined ? '' : value;
      this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
    }
  }

  selectFeedback(drp, item, step) {
    //this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = drp.val == undefined ? '' : drp.val;
    let changeJsonArray = this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList;
    changeJsonArray.forEach(element => {
      element.active = false;
    });
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList = changeJsonArray;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList.find(m => m.id == drp.id).active = true;
    this.dataJson.find(x => x.id == item.id).value = drp.val;
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }

  selectRating(drp, item, step) {
    //this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = drp.val == undefined ? '' : drp.val;
    let changeJsonArray = this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList;
    changeJsonArray.forEach(element => {
      element.active = false;
    });
    changeJsonArray.forEach(element => {

      if (element.id <= drp.id) {
        element.active = true;
      }
    });
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList = changeJsonArray;
    //this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.fillList.find(m=>m.id==drp.id).active=true;
    this.dataJson.find(x => x.id == item.id).value = drp.id;
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }

  onChangesTextArea(value: any, step: any, item: any) {
    this.text = value;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = value == undefined ? '' : value;
    // this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == data.id).selectedValue = value == undefined ? '' : value;

    var textArea = document.getElementById(item.id);
    // this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetHeight = textArea.clientHeight;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetWidth = textArea.clientWidth;

    this.dataJson.find(x => x.id == item.id).value = value == undefined ? '' : value;
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }

  storeDimensions(step: any, item: any) {
    var textArea = document.getElementById(item.id);
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetHeight = textArea.offsetHeight;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetWidth = textArea.offsetWidth;

    //element.value = "is it gonna change? we don't know yet...";
  }

  onresizeMaybe(step: any, item: any) {
    var textArea = document.getElementById(item.id);
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetHeight = textArea.clientHeight + 10;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetWidth = textArea.clientWidth;
  }

  // TextAreaResize(step:any,item:any) { 
  //   var textArea= document.getElementById(item.id);       
  //   this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetHeight = textArea.clientHeight;
  //   this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetWidth =  textArea.clientWidth;
  // } 

  onChangesDate(value: any, step: any, item: any) {
    this.text = value;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.selectedValue = value == undefined ? '' : value;
    // this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == data.id).selectedValue = value == undefined ? '' : value;

    var date = new Date(value);
    var newtdate = "";
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    newtdate = mm + '/' + dd + '/' + yyyy;
    this.dataJson.find(x => x.id == item.id).value = newtdate;//value == undefined ? '' : value.tostring();  
    this.dataJson.find(x => x.id == item.id).name = item.fieldJson.labelName;
  }

  onChangeText(value: any) {
    var data = this.ControlData;
    this.ControlId;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.selectedValue = value == undefined ? '' : value;
    }
    if (this.SelectedControl == "MCQ" || this.SelectedControl == "TrueFalse" || this.SelectedControl == "Rating" || this.SelectedControl == "Feedback") {
      if (this.dataJson.find(x => x.id == this.ControlId))
        this.dataJson.find(x => x.id == this.ControlId).name = value;
    }
    else {
      if (this.dataJson.find(x => x.id == this.ControlId))
        this.dataJson.find(x => x.id == this.ControlId).value = value == undefined ? '' : value;
    }
    //  if(this.dataJson.find(x => x.id == this.ControlId)){
    //   this.dataJson.find(x => x.id == this.ControlId).value = value == undefined ? '' : value;
    // }
  }

  onChangeTextButton(value: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.buttonName = value == undefined ? '' : value;
      //this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id ==  data.id).buttonName = value == undefined ? '' : value;
    }
  }

  onChangeUrlButton(value: any) {
    var data = this.ControlData;
    var url = this.addAnchorsToText(value);
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.buttonURL = url == undefined ? '' : url;
      // this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id ==  data.id).buttonURL = url == undefined ? '' : url;
    }
  }

  insertIntoString(str: string, pos: number, fragment: string) {
    return str.slice(0, pos) + fragment + str.slice(pos + 1, str.length);
  }

  addAnchorsToText(text) {
    // https://www.regextester.com/94502
    const regexp = /((?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+%,;=.]+)/igm;
    const map = {};
    return text.replace(regexp, (_, match, __, pos) => {
      // This map helps us to keep a count of the duplicate matches.
      if (map[match] !== undefined) map[match]++;
      else map[match] = 0;

      // These next few lines handle duplicates. We want to handle cases like this: 
      // <a href="myurl.com">foo</a> bar baz myurl.com.
      let testString = text.replace(new RegExp(escapeRegExp(match), 'ig'), '$');
      let newPos = pos - map[match] * (match.length - 1);
      testString = this.insertIntoString(testString, newPos, match);

      // Detect if the url was found here -> <a href="#here#">
      const hrefRegex = new RegExp(`<a[^>]*href="${escapeRegExp(match)}"[^>]*>[^<]*<\/a>`, 'ig');
      const isHref = hrefRegex.test(testString);

      // Detect if the url was found here -> <a href="...">#here#</a>
      const anchoredRegex = new RegExp(`<a[^>]*>[^<]*${escapeRegExp(match)}[^<]*<\/a>`, 'ig');
      const isAnchored = anchoredRegex.test(testString);


      // If the url is found in href or anchor, then do nothing with it, it needs no further treatment.
      if (isAnchored || isHref) return match;
      const hasProtocol = /^http[s]?:\/\/.*$/igm.test(match);
      //var data = "http://'}${match}";
      return `${hasProtocol ? '' : 'http://'}${match}`;
    });
    function escapeRegExp(text) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
  }

  onTableChange(e: any, data: any, id) {
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.fillList.find(m => m.id == e.target.id).val = e.target.value == undefined ? '' : e.target.value;
    }
    if (this.dataJson.find(x => x.id == e.target.id)) {
      this.dataJson.find(x => x.id == e.target.id).value = e.target.value == undefined ? '' : e.target.value;
    }
  }


  // OnChangeCheckBox($event: any, chk: any, field: any, data: any,childCtrlID:any) { 
  //   if ($event.target.checked) {       
  //     this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues.push(childCtrlID);
  //   }
  //   else
  //   {
  //     this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues.pop(childCtrlID);
  //   } 
  //   if(this.dataJson.find(x => x.id == field.id)){
  //     let slectedValues=this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues;

  //     if(slectedValues.length>0)
  //      this.dataJson.find(x => x.id == field.id).value = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.fillList.filter(n=>slectedValues.includes(n.id)).map(a => a.val).join(',');
  //     else
  //      this.dataJson.find(x => x.id == field.id).value='';
  //   }
  // }

  OnChangeCheckBox($event: any, chk: any, field: any, data: any, childCtrlID: any) {
    if ($event.target.checked) {
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues.push(childCtrlID);
      this.dataJson.find(x => x.id == field.id).value = true;
    }
    else {
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues.pop(childCtrlID);
      this.dataJson.find(x => x.id == field.id).value = false;
    }
    // if(this.dataJson.find(x => x.id == field.id)){
    //   let slectedValues=this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.chkSelectedValues;

    //   if(slectedValues.length>0)
    //    this.dataJson.find(x => x.id == field.id).value = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).fieldJson.fillList.filter(n=>slectedValues.includes(n.id)).map(a => a.val).join(',');
    //   else
    //    this.dataJson.find(x => x.id == field.id).value='';
    // }
  }

  OnChangeCheckBoxGroup($event: any, chk: any, id: any, data: any, childCtrlID: any) {
    if (this.controlAlignArray.find(x => x.id == data.id)) {
      if ($event.target.checked) {
        this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == id).chkSelectedValues.push(childCtrlID);
      } else {
        if (this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == id).chkSelectedValues.find((s) => s == childCtrlID)) {
          this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == id).chkSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }

    if (this.dataJson.find(x => x.id == data.id)) {
      this.dataJson.find(x => x.id == data.id).value = (childCtrlID);
    }
  }


  setDdlValue(e: any, data: any, field) {
    this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == field.id).selectedValue = e.value;
    this.dataJson.find(x => x.id == field.id).value = e.value;
  }


  ifChkChecked(id, data, childCtrlId) {
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      let selectedValue = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.chkSelectedValues;
      //this.dataJson.find(x => x.id == id).value = e.value;
      return selectedValue.includes(childCtrlId);
    }
    return false;
  }



  AddControlCheckBoxGroup(id, data) {
    if (this.controlAlignArray.find(x => x.id == data.id)) {
      let fillList = this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == id).fillList;
      this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == id).fillList.push({
        id: "ctrl-" + (fillList.length + 1),
        val: "",
        offsetX: fillList[fillList.length - 1].offsetX,
        offsetY: fillList[fillList.length - 1].offsetY + 37
      });
      this.checkboxGroupFieldArray = fillList;
    }
  }

  ChangeStep(check) {
    if (check == 1) {
      this.currentStep--;
    } else {
      this.currentStep++;
    }
    this.currentPageName = this.controlAlignArray.find(m => m.step == this.currentStep).pageName;
  }

  FindCurrentStep(controlAlignArray) {
    return controlAlignArray.filter(x => x.step == this.currentStep);
  }

  ChangePageName(val: any) {
    this.currentPageName = val;
    this.controlAlignArray.find(m => m.step == this.currentStep).pageName = val;
  }

  DeleteStep(step: number) {
    this.controlAlignArray = this.controlAlignArray.filter(m => m.step !== step);
    if (step > 1)
      this.currentStep = step - 1;
    else
      this.currentStep = 1;
    for (let index = 0; index < this.controlAlignArray.length; index++) {
      this.controlAlignArray[index].step = index + 1;
    }
    if (this.controlAlignArray.length > 0) {
      this.currentPageName = this.controlAlignArray.find(m => m.step == this.currentStep).pageName;
    }

    if (this.controlAlignArray.length > 0) {
      this.controlAlignArray.map(e => {
        if (e.fields.length > 0) {
          this.SaveButtonDisbled = true;
          return;
        } else {
          this.SaveButtonDisbled = false;
        }
      });
    } else {
      this.SaveButtonDisbled = false;
    }
  }

  GoToPage(step: number) {
    this.currentStep = step;
    this.currentPageName = this.controlAlignArray.find(m => m.step == this.currentStep).pageName;
  }

  Arr = Array;

  AddStep() {
    this.closeDetail();
    if (this.controlAlignArray.length > 0)
      this.currentPageName = "Page" + (this.currentStep + 1);
    if (this.currentStep === this.controlAlignArray.length || this.controlAlignArray.length == 0) {
      this.controlAlignArray.push({
        step: this.controlAlignArray.length + 1,
        fields: [],
        pageName: this.currentPageName
        // id: event.data.name,
        // IsFullWidth:true
      });
      this.currentStep = this.controlAlignArray.length;
      this.currentPageName = this.controlAlignArray.find(m => m.step == this.currentStep).pageName;
    } else {
      this.controlAlignArray.splice((this.currentStep), 0, {
        step: this.currentStep + 1,
        fields: [],
        pageName: this.currentPageName + 1
        // id: event.data.name,
        // IsFullWidth:true
      });

      for (let index = 0; index < this.controlAlignArray.length; index++) {
        this.controlAlignArray[index].step = index + 1;
      }

      this.currentStep = this.currentStep + 1;
      this.currentPageName = this.controlAlignArray.find(m => m.step == this.currentStep).pageName;
    }
    this.SaveButtonDisbled = true;
    // if (this.controlAlignArray.length > 0) {
    //   this.controlAlignArray.map(e => {
    //     if (e.fields.length > 0) {
    //       this.SaveButtonDisbled = true;
    //       return;
    //     } else {
    //       this.SaveButtonDisbled = false;
    //     }
    //   });
    // }

  }

  LabelName: string = "";
  FeildName: string = "";
  backgroundColorshow:boolean=false;

  onDrop(event: any) {
    this.backgroundColorshow=false;
    this.backgroundColor="";
    this.textColor="";
    if ((event.dropEffect === "copy" || event.dropEffect === "move")) {
      this.characterlimit = 40;
      this.fontsize = 14;
      this.fontfamily = 'Arial';
      if (event.data.labelName == null || event.data.labelName == undefined) {
        event.data.labelName = event.data.fieldName;
        this.FeildName = event.data.fieldName;
        this.LabelName = event.data.fieldName;
      } else {
        this.LabelName = event.data.labelName;
        this.FeildName = event.data.fieldName;
      }


      event.data.name = event.data.fieldTypeName + '-' + new Date().getTime();
      let fillListArray: any = [];
      let fillList: any = [];
      this.buttonText = "Button";
      this.acceptOrdeclineText = 'Approve';
      this.buttonURL = "";
      this.acceptchecked = true;
      this.declinechecked = false;
      var textaligns: string = "left";
      //var addressGrp: string = "";

      this.OpentoolDetail(event.data.fieldTypeName);
      if (event.data.fieldTypeName == 'TrueFalse' || event.data.fieldTypeName == 'Rating' || this.SelectedControl == "Feedback") {
        fillList = event.data.fillList;
      }
      if (event.data.fieldTypeName == 'MultiSelect' || event.data.fieldTypeName == 'Dropdown' ||
        event.data.fieldTypeName == 'Checkbox' || event.data.fieldTypeName == 'Radio' ||
        event.data.fieldTypeName == 'CheckBoxGroup' ||
        event.data.fieldTypeName == 'File' || event.data.fieldTypeName == 'Image' ||
        event.data.fieldTypeName == 'Date' || event.data.fieldTypeName == 'Currency') {

        let drpValue = event.data.defaultValue.replace(/,\s*$/, "");
        if(event.data.folderName!=undefined && event.data.folderName!=null && event.data.folderName!="" && event.data.folderName.toLowerCase()=="core" && event.data.fieldName.toLowerCase()=="type")
        { 
          if(this.coreSubFolderList!=null && this.coreSubFolderList!=undefined && this.coreSubFolderList.length>0)
             fillListArray=this.coreSubFolderList.map(folder => folder.folderName);
          else
             fillListArray=[];
        }
        else if(event.data.folderName!=undefined && event.data.folderName!=null && event.data.folderName!="" && event.data.folderName.toLowerCase()=="contact" && event.data.fieldName.toLowerCase()=="type")
          {
            if(this.contactSubFolderList!=null && this.contactSubFolderList!=undefined && this.contactSubFolderList.length>0)
              fillListArray=this.contactSubFolderList.map(folder => folder.folderName);
            else
             fillListArray=[];
          }
        else if(event.data.folderName!=undefined && event.data.folderName!=null && event.data.folderName!="" && event.data.folderName.toLowerCase()=="company" && event.data.fieldName.toLowerCase()=="type")
            { 
              if(this.companySubFolderList!=null && this.companySubFolderList!=undefined && this.companySubFolderList.length>0)
                 fillListArray=this.companySubFolderList.map(folder => folder.folderName);
              else
               fillListArray=[];
            }
        else
        {
         fillListArray = drpValue.split(',');
        }

        if (event.data.fieldTypeName == 'Dropdown' || event.data.fieldTypeName == 'MCQ') {
          if (event.data.fieldID > 0) {
            this.dropdownddisabled = true;
          } else {
            this.dropdownddisabled = false;
          }
          this.dropdownFieldArray = [];
          fillListArray.forEach((element) => {
            let copyModel = Object.assign({});
            copyModel.val = element;
            this.dropdownFieldArray.push(copyModel);
          });
          this.offsetWidth = 115;
          this.offsetHeight = 28;
        }
        if (event.data.fieldTypeName == 'Checkbox') {
          if (event.data.fieldID > 0) {
            this.checkboxdisabled = true;
          } else {
            this.checkboxdisabled = false;
          }
          this.checkboxFieldArray = [];
          fillListArray.forEach((element) => {
            let copyModel = Object.assign({});
            copyModel.val = element;
            this.checkboxFieldArray.push(copyModel);
          });
          this.offsetWidth = 15;
          this.offsetHeight = 15;
        }



        for (let index = 0; index < fillListArray.length; index++) {

          var elementt = fillListArray[index];

          if (event.data.fieldID == 0 && event.data.fieldTypeName == 'Checkbox') {
            fillList.push({
              id: 'ctrl-' + index,
              val: elementt,
            });
          }

          if (event.data.fieldID > 0 && event.data.fieldTypeName == 'Checkbox') {
            if (elementt == "''") {
              elementt = "";
            }
            fillList.push({
              id: 'ctrl-' + index,
              val: elementt,
            });
          }

          if (event.data.fieldTypeName != 'Checkbox') {
            if (elementt == "''") {
              elementt = "";
            }
            if(event.data.fieldName!="" && event.data.fieldName!=undefined && event.data.fieldName!=null && event.data.fieldName.toLowerCase()=="type")
           {
            fillList.push({
              id: 'ctrl-' + index,
              val: elementt,
            });
           }
          //else if (index !== 0) {
            else {
              fillList.push({
                id: 'ctrl-' + index,
                val: elementt,
              });
          }
          }
        }
      }

      if (event.data.fieldTypeName == 'Table') {
        this.tblid = undefined;
        this.tblrowsnumber = 2;
        this.tblclmnumber = 2;
        this.GettableWithFields(2, 2);
        this.offsetWidth = 375;
        this.offsetHeight = 60;

        for (let r = 0; r < this.rows.length; r++) {
          for (let c = 0; c < this.column.length; c++) {
            fillList.push({
              val: '',
              id: event.data.name + 'txt-' + (r + 1) + '' + (c + 1),
              ctrlType: 'text'
            });
          }
        }
      }

      if (event.data.fieldTypeName == "Textbox" || event.data.fieldTypeName == "Number"
        || event.data.fieldTypeName == "Single-Line" || event.data.fieldTypeName == "Currency" ||
        event.data.fieldTypeName == "URL" || event.data.fieldTypeName == "Address") {
        this.offsetWidth = 150;
        this.offsetHeight = 30;
      }

      if (event.data.fieldName == 'Address' || event.data.fieldTypeName == 'Address') {
        this.filledJsonForCity(event);
        this.filledJsonForState(event);
        this.filledJsonForZip(event);
      }

      if (event.data.fieldTypeName == 'Textarea') {
        this.offsetWidth = 676;
        this.offsetHeight = 70;
      }


      if (event.data.fieldTypeName == 'Signature' || event.data.fieldTypeName == 'Initials') {
        this.offsetWidth = 135;
        this.offsetHeight = 45;
      }

      if (event.data.fieldTypeName == 'ApproveOrDecline' || event.data.fieldTypeName == 'Button') {
        this.offsetWidth = 75;
        this.offsetHeight = 35;
        textaligns = "Center";
      }

      if (event.data.fieldTypeName == 'Date' || event.data.fieldTypeName == 'Time') {
        this.offsetWidth = 170;
        this.offsetHeight = 30;
        if (event.data.fieldTypeName == 'Date') {
          if (event.data.fieldName == "" || event.data.fieldName == undefined || event.data.fieldName == null) {
            event.data.fieldName = "";
          }
        }

        if (event.data.fieldTypeName == 'Time') {
          if (event.data.fieldName == "" || event.data.fieldName == undefined || event.data.fieldName == null) {
            event.data.fieldName = "";
          }
        }
      }

      if (event.data.fieldTypeName == 'Location') {
        this.offsetWidth = 90;
        this.offsetHeight = 50;
      }

      if (event.data.fieldTypeName == 'File' || event.data.fieldTypeName == 'Image') {
        this.offsetWidth = 100;
        this.offsetHeight = 60;
      }

      if (event.data.fieldTypeName == 'MultiSelect') {
        this.offsetWidth = 115;
        this.offsetHeight = 28;
      }

      if(event.data.fieldTypeName == 'Button'){
        this.backgroundColorshow=true;
        this.backgroundColor="#03a9f4";
        this.textColor="#FFFFFF";
       }

      let fieldJson = {
        "childFieldType": 0,
        "isEditable": false,
        "id": event.data.name,
        "fieldID": event.data.fieldID,
        "fieldName": event.data.fieldName,
        "labelName": event.data.labelName,
        "name": event.data.labelName,
        "placeholderName": event.data.placeholderName,
        "folderID": event.data.folderID,
        "folderName": event.data.folderName,
        "subFolderName": event.data.subFolderName,
        "fieldTypeID": event.data.fieldTypeID,
        "fieldTypeName": event.data.fieldTypeName,
        "placeholder": event.data.placeholder,
        "defaultValue": event.data.defaultValue,
        "fillList": fillList,
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "isShowListing": event.data.isShowListing,
        "readonly": false,
        "charLimit": "40",
        "fontSize": "14px",
        "labelfontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "labelfontstyle": "",
        "fontweight": "",
        "labelfontweight": "",
        "textdecoration": "",
        "labeltextdecoration": "",
        "fontColor": this.textColor,
        "labelfontColor": "",
        "fontfamily": "Arial",
        "labelfontfamily": "Arial",
        //"offsetX": event.event.offsetX,
        //"offsetY": event.event.offsetY,
        "height": 0,
        "width": 0,
        "Imageheight": "100px",
        "Imagewidth": "100px",
        "textalign": textaligns,//"left",       
        "chkSelectedValues": [],
        "rbSelectedValues": ['ctrl-0'],
        "fieldNames": event.data.fieldNames,
        "buttonText": event.data.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
        "signatureBase64": "",
        "signatureText": '',
        "colorCode": this.colorselected,
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "backgroundColor": this.backgroundColor,
        "buttonName": "Button",
        "buttonURL": "",
        "ShowtoolDetail": true,
        "offsetWidth": this.offsetWidth,
        "offsetHeight": this.offsetHeight,
        "showRequiredControls": false,
        "AddressGroup": event.data.name,
        "penColor": "#000000f2",

      }


      if (event.data.fieldTypeName == 'CheckBoxGroup') {
        if (event.data.fieldID > 0) {
          this.checkboxdisabled = true;
        } else {
          this.checkboxdisabled = false;
        }
        this.checkboxGroupFieldArray = [];
        this.checkboxGroupFieldArray = fillList;
      }

      if (event.data.fieldTypeName == 'Table') {
        this.tblid = event.data.name;
      }

      if (event.dropEffect === "copy")
        this.text = "";
      // this.ControlId = event.data.name;
      // this.ControlData = fieldJson;
      this.isRequired = false;
      this.isShowListing = false;
      if (event.data.fieldTypeName == 'HtmlEditor' || event.data.fieldTypeName == 'Space' || event.data.fieldTypeName == 'Devider' || event.data.fieldTypeName == 'URL' || event.data.fieldTypeName == 'TextSingle' || event.data.fieldTypeName == 'Paragraph') {
        this.isShowListing = true;
      }
      this.readonly = false;
     // this.textColor = "";
      this.fontstyle = "";
      this.textdecoration = "";
      this.fontweight = "";
      this.textalign = "";
      this.brushColor = "";

      var folderID: number = 0;
      var folderName: string = "";
      var fieldTypeName: string = "";

      folderID = event.data.folderID;
      folderName = event.data.folderName;
      fieldTypeName = event.data.fieldTypeName;

      if (this.controlAlignArray.length > 0) {
        if (!this.controlAlignArray.find(m => m.step == this.currentStep)) {
          this.controlAlignArray.push({
            step: this.controlAlignArray.length + 1,
            fields: [],
            pageName: "Page" + (this.controlAlignArray.length + 1)
            // id: event.data.name,
            // IsFullWidth:true
          });
          this.currentPageName = "Page" + (this.controlAlignArray.length + 1);
          this.controlAlignArray.find(x => x.step == this.currentStep).fields.push({
            fieldJson: fieldJson,
            id: event.data.name,
            IsFullWidth: "fullWidth",
            alignBlock: "alignBlockleft",
            folderID: folderID,
          });
          if (event.data.fieldTypeName == 'Table') {
            fillList.forEach(ct => {
              this.dataJson.push({
                id: ct.id,
                fieldId: event.data.fieldID,
                name: 'Table',
                value: "",
                ctrlType: ct.ctrlType,
                folderID: folderID,
                folderName: folderName,
                fieldTypeName: fieldTypeName,
                isShowListing: event.data.isShowListing
              });
            });
          }
          else if (event.data.fieldTypeName == 'Signature') {
            this.dataJson.push({
              id: fieldJson.id,
              fieldId: event.data.fieldID,
              name: fieldJson.fieldName,
              value: "",
              ctrlType: 'Signature',
              folderID: folderID,
              folderName: folderName,
              fieldTypeName: fieldTypeName,
              isShowListing: event.data.isShowListing
            });
          }
          else if (event.data.fieldTypeName == 'Initials') {
            this.dataJson.push({
              id: fieldJson.id,
              fieldId: event.data.fieldID,
              name: fieldJson.fieldName,
              value: "",
              ctrlType: 'Initials',
              folderID: folderID,
              folderName: folderName,
              fieldTypeName: fieldTypeName,
              isShowListing: event.data.isShowListing
            });
          }
          else {
            if (event.data.fieldTypeName == 'Table') {
              fillList.forEach(ct => {
                this.dataJson.push({
                  id: ct.id,
                  fieldId: event.data.fieldID,
                  name: 'Table',
                  value: "",
                  ctrlType: ct.ctrlType,
                  folderID: folderID,
                  folderName: folderName,
                  fieldTypeName: fieldTypeName,
                  isShowListing: event.data.isShowListing
                });
              });
            }
            else {
              this.dataJson.push({
                id: fieldJson.id,
                fieldId: event.data.fieldID,
                name: fieldJson.fieldName,
                value: "",
                ctrlType: 'text',
                folderID: folderID,
                folderName: folderName,
                fieldTypeName: fieldTypeName,
                isShowListing: event.data.isShowListing
              });
            }
          }
        }
        else {
          this.controlAlignArray.find(x => x.step == this.currentStep).fields.push({
            fieldJson: fieldJson,
            id: event.data.name,
            IsFullWidth: "fullWidth",
            alignBlock: "alignBlockleft",
            folderID: folderID,
          });
          if (event.data.fieldTypeName == 'Table') {
            fillList.forEach(ct => {
              this.dataJson.push({
                id: ct.id,
                fieldId: event.data.fieldID,
                name: 'Table',
                value: "",
                ctrlType: ct.ctrlType,
                folderID: folderID,
                folderName: folderName,
                fieldTypeName: fieldTypeName,
                isShowListing: event.data.isShowListing
              });
            });
          }
          else if (event.data.fieldTypeName == 'Signature') {
            this.dataJson.push({
              id: fieldJson.id,
              fieldId: event.data.fieldID,
              name: fieldJson.fieldName,
              value: "",
              ctrlType: 'Signature',
              folderID: folderID,
              folderName: folderName,
              fieldTypeName: fieldTypeName,
              isShowListing: event.data.isShowListing
            });
          }
          else if (event.data.fieldTypeName == 'Initials') {
            this.dataJson.push({
              id: fieldJson.id,
              fieldId: event.data.fieldID,
              name: fieldJson.fieldName,
              value: "",
              ctrlType: 'Initials',
              folderID: folderID,
              folderName: folderName,
              fieldTypeName: fieldTypeName,
              isShowListing: event.data.isShowListing
            });
          }
          else {
            this.dataJson.push({
              id: fieldJson.id,
              fieldId: event.data.fieldID,
              name: fieldJson.fieldName,
              value: "",
              ctrlType: 'text',
              folderID: folderID,
              folderName: folderName,
              fieldTypeName: fieldTypeName,
              isShowListing: event.data.isShowListing
            });
          }
        }
      } else {
        this.controlAlignArray.push({
          step: this.currentStep,
          fields: [],
          pageName: this.currentPageName,
          // id: event.data.name,
          // IsFullWidth:true
        });
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.push({
          fieldJson: fieldJson,
          id: event.data.name,
          IsFullWidth: "fullWidth",
          alignBlock: "alignBlockleft",
          folderID: folderID,
        });
        if (event.data.fieldTypeName == 'Table') {
          fillList.forEach(ct => {
            this.dataJson.push({
              id: ct.id,
              fieldId: event.data.fieldID,
              name: 'Table',
              value: "",
              ctrlType: ct.ctrlType,
              folderID: folderID,
              folderName: folderName,
              fieldTypeName: fieldTypeName,
              isShowListing: event.data.isShowListing
            });
          });
        } else if (event.data.fieldTypeName == 'Signature') {
          this.dataJson.push({
            id: fieldJson.id,
            fieldId: event.data.fieldID,
            name: fieldJson.fieldName,
            value: "",
            ctrlType: 'Signature',
            folderID: folderID,
            folderName: folderName,
            fieldTypeName: fieldTypeName,
            isShowListing: event.data.isShowListing
          });
        }
        else if (event.data.fieldTypeName == 'Initials') {
          this.dataJson.push({
            id: fieldJson.id,
            fieldId: event.data.fieldID,
            name: fieldJson.fieldName,
            value: "",
            ctrlType: 'Initials',
            folderID: folderID,
            folderName: folderName,
            fieldTypeName: fieldTypeName,
            isShowListing: event.data.isShowListing
          });
        } else {
          this.dataJson.push({
            id: fieldJson.id,
            fieldId: event.data.fieldID,
            name: fieldJson.fieldName,
            value: "",
            ctrlType: 'text',
            folderID: folderID,
            folderName: folderName,
            fieldTypeName: fieldTypeName,
            isShowListing: event.data.isShowListing
          });
        }
      }

      this.ControlId = event.data.name;
      this.ControlData = this.controlAlignArray;

      if (event.data.fieldTypeName == 'Table') {
        this.tbldata = this.controlAlignArray && this.controlAlignArray.find(m => m.step == this.currentStep);
        this.tblid = event.data.name;
      }


      if (this.controlAlignArray.length > 0) {
        this.controlAlignArray.map(e => {
          if (e.fields.length > 0) {
            this.SaveButtonDisbled = true;
            return;
          } else {
            this.SaveButtonDisbled = false;
          }
        });
      }


    }
  }

  fieldJsonForCity: any = [] = [];
  fieldJsonForState: any = [] = [];
  fieldJsonForZip: any = [] = [];

  filledJsonForCity(event) {
    let fillList: any = [];
    var textaligns: string = "left";
    this.fieldJsonForCity = [];

    this.fieldJsonForCity = {
      "childFieldType": 3,
      "isEditable": false,
      "id": 'City' + '-' + new Date().getTime(),//event.data.name,
      "fieldID": event.data.fieldID,
      "fieldName": 'City',//event.data.fieldName,
      "labelName": "City",
      "placeholderName": "City",
      "folderID": event.data.folderID,
      "folderName": event.data.folderName,
      "subFolderName": event.data.subFolderName,
      "fieldTypeID": event.data.fieldTypeID,
      "fieldTypeName": "City",//event.data.fieldTypeName,
      "placeholder": "City",
      "defaultValue": event.data.defaultValue,
      "fillList": fillList,
      "FileData": [],
      "ImageData": [],
      "rows": this.rows,
      "column": this.column,
      "selectedValue": '',
      "isRequired": false,
      "isShowListing": false,
      "readonly": false,
      "charLimit": "40",
      "fontSize": "14px",
      "fontName": "",
      "fontstyle": "",
      "fontweight": "",
      "textdecoration": "",
      "fontColor": "",
      "fontfamily": "Arial",
      "offsetX": event.event.offsetX,
      "offsetY": event.event.offsetY + 50,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign": textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": ['ctrl-0'],
      "fieldNames": event.data.fieldNames,
      "buttonText": event.data.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
      "signatureBase64": "",
      "signatureText": '',
      "drawBase64": "",
      "colorCode": this.colorselected,
      "colorCodeAlpha": event.data.fieldTypeName == "StrikeThrough" ? this.hexToRGBA(this.selectedColorCode, 0.3) : this.colorselectedAlpha,
      'signInitialFontFamily': '',
      'Lat': '',
      'Long': '',
      "selectedParticipant": this.selectedParticipant,
      "backgroundColor": "",
      "buttonName": "Button",
      "buttonURL": "",
      "brushColor": undefined,
      "rotation": this.rotationByDegree,
      "ShowtoolDetail": true,
      "offsetWidth": this.offsetWidth,
      "offsetHeight": this.offsetHeight,
      "showRequiredControls": false,
      "AddressGroup": event.data.name,
    }
  }

  filledJsonForState(event) {
    let fillList: any = [];
    var textaligns: string = "left";
    this.fieldJsonForState = [];


    this.fieldJsonForState = {
      "childFieldType": 2,
      "isEditable": false,
      "id": 'State' + '-' + new Date().getTime(),//event.data.name,
      "fieldID": event.data.fieldID,
      "fieldName": 'State',//event.data.fieldName,
      "labelName": "State",
      "placeholderName": "State",
      "folderID": event.data.folderID,
      "folderName": event.data.folderName,
      "subFolderName": event.data.subFolderName,
      "fieldTypeID": event.data.fieldTypeID,
      "fieldTypeName": "State",//event.data.fieldTypeName,
      "placeholder": "State",
      "defaultValue": event.data.defaultValue,
      "fillList": fillList,
      "FileData": [],
      "ImageData": [],
      "rows": this.rows,
      "column": this.column,
      "selectedValue": '',
      "isRequired": false,
      "isShowListing": false,
      "readonly": false,
      "charLimit": "40",
      "fontSize": "14px",
      "fontName": "",
      "fontstyle": "",
      "fontweight": "",
      "textdecoration": "",
      "fontColor": "",
      "fontfamily": "Arial",
      "offsetX": event.event.offsetX + 162,
      "offsetY": event.event.offsetY + 50,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign": textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": ['ctrl-0'],
      "fieldNames": event.data.fieldNames,
      "buttonText": event.data.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
      "signatureBase64": "",
      "signatureText": '',
      "drawBase64": "",
      "colorCode": this.colorselected,
      "colorCodeAlpha": event.data.fieldTypeName == "StrikeThrough" ? this.hexToRGBA(this.selectedColorCode, 0.3) : this.colorselectedAlpha,
      'signInitialFontFamily': '',
      'Lat': '',
      'Long': '',
      "selectedParticipant": this.selectedParticipant,
      "backgroundColor": "",
      "buttonName": "Button",
      "buttonURL": "",
      "brushColor": undefined,
      "rotation": this.rotationByDegree,
      "ShowtoolDetail": true,
      "offsetWidth": this.offsetWidth,
      "offsetHeight": this.offsetHeight,
      "showRequiredControls": false,
      "AddressGroup": event.data.name
    }
  }

  filledJsonForZip(event) {
    let fillList: any = [];
    var textaligns: string = "left";
    this.fieldJsonForZip = [];

    this.fieldJsonForZip = {
      "childFieldType": 4,
      "isEditable": false,
      "id": 'Zip' + '-' + new Date().getTime(),//event.data.name,
      "fieldID": event.data.fieldID,
      "fieldName": 'Zip',//event.data.fieldName,
      "labelName": "Zip",
      "placeholderName": "Zip",
      "folderID": event.data.folderID,
      "folderName": event.data.folderName,
      "subFolderName": event.data.subFolderName,
      "fieldTypeID": event.data.fieldTypeID,
      "fieldTypeName": "Zip",//event.data.fieldTypeName,
      "placeholder": "Zip Code",
      "defaultValue": event.data.defaultValue,
      "fillList": fillList,
      "FileData": [],
      "ImageData": [],
      "rows": this.rows,
      "column": this.column,
      "selectedValue": '',
      "isRequired": false,
      "isShowListing": false,
      "readonly": false,
      "charLimit": "40",
      "fontSize": "14px",
      "fontName": "",
      "fontstyle": "",
      "fontweight": "",
      "textdecoration": "",
      "fontColor": "",
      "fontfamily": "Arial",
      "offsetX": event.event.offsetX + 326,
      "offsetY": event.event.offsetY + 50,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign": textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": ['ctrl-0'],
      "fieldNames": event.data.fieldNames,
      "buttonText": event.data.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
      "signatureBase64": "",
      "signatureText": '',
      "drawBase64": "",
      "colorCode": this.colorselected,
      "colorCodeAlpha": event.data.fieldTypeName == "StrikeThrough" ? this.hexToRGBA(this.selectedColorCode, 0.3) : this.colorselectedAlpha,
      'signInitialFontFamily': '',
      'Lat': '',
      'Long': '',
      "selectedParticipant": this.selectedParticipant,
      "backgroundColor": "",
      "buttonName": "Button",
      "buttonURL": "",
      "brushColor": undefined,
      "rotation": this.rotationByDegree,
      "ShowtoolDetail": true,
      "offsetWidth": this.offsetWidth,
      "offsetHeight": this.offsetHeight,
      "showRequiredControls": false,
      "AddressGroup": event.data.name
    }
  }


  cityselected(event: MatAutocompleteSelectedEvent, data: any, id) {
    var value = event.option.value;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = value == undefined ? '' : value;
      this.imagesWithFields = this.imagesWithFields;
      this.text = value;
    }
  }


  zipselected(event: MatAutocompleteSelectedEvent, data: any, id) {
    var value = event.option.value;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = value == undefined ? '' : value;
      this.imagesWithFields = this.imagesWithFields;
      this.text = value;
    }
  }

  replacecount: any = 0;
  replaceIconHasClass: any = false;
  isClickReplaceEnabled: any;
  movingOffset = { x: 0, y: 0 };
  endOffset = { x: 0, y: 0 };



  hexToRGBA(hex, opacity) {
    if (hex == undefined || (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')) == null || (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')) == undefined) {
      return;
    }
    return (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')).map(function (l) { return parseInt(hex.length % 2 ? l + l : l, 16) }).concat(isFinite(opacity) ? opacity : 1).join(',');
  }


  RGBToHex(rgb) {
    // Choose correct separator
    let sep = rgb.indexOf(",") > -1 ? "," : " ";
    // Turn "rgb(r,g,b)" into [r,g,b]
    rgb = rgb.substr(4).split(")")[0].split(sep);

    let r = (+rgb[0]).toString(16),
      g = (+rgb[1]).toString(16),
      b = (+rgb[2]).toString(16);

    if (r.length == 1)
      r = "0" + r;
    if (g.length == 1)
      g = "0" + g;
    if (b.length == 1)
      b = "0" + b;

    return "#" + r + g + b;
  }

  onStart(event) {

  }

  onStop(event) {

  }

  contolToPaste = undefined;
  controlId2Paste = "";
  acceptchecked: boolean = false;
  declinechecked: boolean = false;
  isControlKeyPressed: boolean = false;
  filenameForSign = "";


  CloneControl(data: any, id: any, item: any, items: any) {

    this.contolToPaste = JSON.parse(JSON.stringify(data));

    var ctrl2Paste = this.contolToPaste.fields.find(x => x.id == id);
    ctrl2Paste.id = items.fieldTypeName + '-' + new Date().getTime();

    if (items.fieldTypeName == "Table") {
      var fillList = [];
      var tablelist = [];
      fillList = ctrl2Paste.fieldJson.fillList;
      if (fillList.length > 0) {
        for (var i = 0, len = fillList.length; i < len; ++i) {
          var ids = "";
          var checkid = fillList[i].id.split('-');
          if (checkid.length > 0) {
            ids = checkid[2];
          }
          this.dataJson.push({
            id: ctrl2Paste.id + 'txt-' + ids,
            name: 'Table',
            value: fillList[i].val,
            ctrlType: "text",
            folderID: items.folderID,
            folderName: items.folderName,
            fieldTypeName: items.fieldTypeName,
            isShowListing: items.isShowListing
          });
          tablelist.push({
            id: ctrl2Paste.id + 'txt-' + ids,
            val: fillList[i].val,
            ctrlType: "text",
            folderID: items.folderID,
            folderName: items.folderName,
            fieldTypeName: items.fieldTypeName,
            isShowListing: items.isShowListing
          });
        }
      }
    }

    //  var index = this.controlAlignArray.findIndex(x => x.step === step);   
    //  var obj={    
    //   IsFullWidth: true,
    //   fieldJson:[],
    //   id: ctrl2Paste.id
    // }  

    // this.controlAlignArray[0].fields.splice(index+1,0,obj);
    this.controlAlignArray.find(x => x.step == data.step).fields.push(ctrl2Paste);
    if (items.fieldTypeName == "Table") {
      this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == ctrl2Paste.id).fieldJson.fillList = tablelist;
    }
    this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == ctrl2Paste.id).fieldJson.id = ctrl2Paste.id;
    this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == ctrl2Paste.id).fieldJson.AddressGroup = ctrl2Paste.id;

    this.ControlData = item;
    this.ControlId = item.id;

    if (items.fieldTypeName == 'Signature') {
      this.dataJson.push({
        id: ctrl2Paste.id,
        name: items.fieldTypeName,
        value: "",
        ctrlType: 'Signature',
        folderID: items.folderID,
        folderName: items.folderName,
        fieldTypeName: items.fieldTypeName,
        isShowListing: items.isShowListing
      });
      return;
    }
    if (items.fieldTypeName == 'Initials') {
      this.dataJson.push({
        id: ctrl2Paste.id,
        name: items.fieldTypeName,
        value: "",
        ctrlType: 'Initials',
        folderID: items.folderID,
        folderName: items.folderName,
        fieldTypeName: items.fieldTypeName,
        isShowListing: items.isShowListing
      });
      return;
    }
    if (items.fieldTypeName == 'Image') {
      this.dataJson.push({
        id: ctrl2Paste.id,
        name: items.fieldTypeName,
        value: "",
        ctrlType: 'Image',
        folderID: items.folderID,
        folderName: items.folderName,
        fieldTypeName: items.fieldTypeName,
        isShowListing: items.isShowListing
      });
      return;
    }
    if (items.fieldTypeName == 'File') {
      this.dataJson.push({
        id: ctrl2Paste.id,
        name: items.fieldTypeName,
        value: "",
        ctrlType: 'File',
        folderID: items.folderID,
        folderName: items.folderName,
        fieldTypeName: items.fieldTypeName,
        isShowListing: items.isShowListing
      });
      return;
    }
    if (items.fieldTypeName != 'Signature' && items.fieldTypeName != 'Initials' &&
      items.fieldTypeName != 'Image' && items.fieldTypeName != 'File' && items.fieldTypeName != 'Table') {
      this.dataJson.push({
        id: ctrl2Paste.id,
        name: items.fieldTypeName,
        value: "",
        ctrlType: 'text',
        folderID: items.folderID,
        folderName: items.folderName,
        fieldTypeName: items.fieldTypeName,
        isShowListing: items.isShowListing
      });
    }
  }


  // CloneControl(datas:any,id:any,item:any){    
  //   return;
  //   this.contolToPaste = JSON.parse(JSON.stringify(datas));
  //   var index = this.controlAlignArray.findIndex(item => item.id === id);

  //   var ctrl2Paste = this.contolToPaste.fields.find(x => x.id == id);
  //   ctrl2Paste.id = item.fieldTypeName + '-' + new Date().getTime();
  //   ctrl2Paste.AddressGroup = ctrl2Paste.id;

  //    var data={
  //     step: "Step1",
  //     fields:[],
  //     id: ctrl2Paste.id
  //   }  

  //   this.controlAlignArray.splice(index+1,0,data);
  //   this.controlAlignArray.find(x => x.id == ctrl2Paste.id).fields.push(ctrl2Paste);  

  //   this.ControlData = data;
  //   this.ControlId = data.id;
  // }

  fullWidth(step: any, item: any) {
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).IsFullWidth = "fullWidth";
    this.ControlData = step;
    this.ControlId = step.id;
  }

  halfWidth(step: any, item: any) {
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).IsFullWidth = "halfWidth";
    this.ControlData = step;
    this.ControlId = step.id;
  }

  GettableWithFields(rows: any, coloumn: any) {
    this.rows = [];
    this.column = [];
    for (var i = 0, len = rows; i < len; ++i) {
      var req = {
      }
      this.rows.push(req)
    }
    for (var i = 0, len = coloumn; i < len; ++i) {
      var req = {
      }
      this.column.push(req)
    }

    if (this.tblid != undefined) {
      if (this.controlAlignArray.find(x => x.step == this.tbldata.step)) {
        let oldFillList = this.controlAlignArray.find(x => x.step == this.tbldata.step).fields.find(m => m.id == this.tblid).fieldJson.fillList;
        let fillList = [];
        for (let r = 0; r < this.rows.length; r++) {
          for (let c = 0; c < this.column.length; c++) {
            if (oldFillList.some(m => m.id == 'txt-' + (r + 1) + '' + (c + 1))) {
              fillList.push({
                val: oldFillList.find(m => m.id == 'txt-' + (r + 1) + '' + (c + 1)).val,
                id: this.tblid + 'txt-' + (r + 1) + '' + (c + 1)
              });
            } else {
              fillList.push({
                val: '',
                id: this.tblid + 'txt-' + (r + 1) + '' + (c + 1)
              });
            }
          }
        }

        this.controlAlignArray.find(x => x.step == this.tbldata.step).fields.find(m => m.id == this.tblid).fieldJson.rows = this.rows;
        this.controlAlignArray.find(x => x.step == this.tbldata.step).fields.find(m => m.id == this.tblid).fieldJson.column = this.column;
        this.controlAlignArray.find(x => x.step == this.tbldata.step).fields.find(m => m.id == this.tblid).fieldJson.fillList = fillList;

      }
    }
  }

  onChangetblrows(rows: any) {
    if (isNaN(rows)) {
      this.toastr.warning('String not allowed.');
    } else {
      this.tblcoloumn = (<HTMLInputElement>document.getElementById('txt-tbl-column')).value;
      if ((rows > 0 && rows <= 10) && (this.tblcoloumn > 0 && this.tblcoloumn <= 10)) {
        if (rows == '' || rows == 0 || this.tblcoloumn == '' || this.tblcoloumn == 0) {
          return;
        }
        this.rows = [];
        this.column = [];
        this.tblrows = Number(rows);
        if (this.tblcoloumn == undefined) {
          this.tblcoloumn = 2;
        }
        this.GettableWithFields(Number(rows), Number(this.tblcoloumn));
      } else {
        if ((rows < 1 && rows != "") && (this.tblcoloumn > 0 || this.tblcoloumn <= 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Rows are allowed.');
        } else if (rows == "" && (this.tblcoloumn > 0 || this.tblcoloumn <= 10)) {
          return;
        } else if (rows >= 10 && (this.tblcoloumn > 0 && this.tblcoloumn <= 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Rows are allowed.');
        } else if ((rows >= 10 || rows < 1) && (this.tblcoloumn < 0 || this.tblcoloumn > 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Rows and 10 Columns are allowed.');
        } else if ((rows <= 10 || rows > 0) && (this.tblcoloumn < 0 || this.tblcoloumn > 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Rows are allowed.');
        } else {
          return;
        }
      }
    }

  }


  onChangetblclm(clm: any) {
    if (isNaN(clm)) {
      this.toastr.warning('String not allowed.');
    } else {
      this.tblrows = (<HTMLInputElement>document.getElementById('txt-tbl-row')).value;
      if ((clm > 0 && clm <= 10) && (this.tblrows > 0 && this.tblrows <= 10)) {

        if (clm == '' || clm == 0 || this.tblrows == '' || this.tblrows == 0) {
          return;
        }
        this.rows = [];
        this.column = [];
        this.tblcoloumn = Number(clm);
        if (this.tblrows == undefined) {
          this.tblrows = 2;
        }
        this.GettableWithFields(Number(this.tblrows), Number(clm));
      } else {
        if ((clm < 1 && clm != "") && (this.tblrows > 0 || this.tblrows <= 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Columns are allowed.');
        } else if (clm == "" && (this.tblrows > 0 || this.tblrows <= 10)) {
          return;
        } else if (clm >= 10 && (this.tblrows > 0 && this.tblrows <= 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Columns are allowed.');
        } else if ((clm < 1 || clm >= 10) && (this.tblrows < 0 || this.tblrows > 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Columns and 10 Rows are allowed. ');
        } else if ((clm > 0 || clm <= 10) && (this.tblrows < 0 || this.tblrows > 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Columns are allowed.');
        } else {
          return;
        }
      }
    }

  }

  getColumnValue(data: any, tblId: any, row: any, col: any) {
    let id = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == tblId).fieldJson.id + 'txt-' + row + col;
    let val = '';
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      val = this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == tblId).fieldJson.fillList.find(m => m.id == id).val;
    }
    return val

    // let id = 'txt-' + row + col;
    // let val = '';
    // if (this.controlAlignArray.find(x => x.id == data.id)) {
    //   val = this.controlAlignArray.find(x => x.id == data.id).fields.find(m => m.id == tblId).fillList.find(m => m.id == id).val;
    // }
    // return val;
  }


  onChangeLabelName(LabelName: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.labelName = LabelName;
    }
    if (this.dataJson.find(x => x.id == this.ControlId)) {
      this.dataJson.find(x => x.id == this.ControlId).name = LabelName;

    }
  }

  // PlaceHolder Name Change
  onChangeFeildName(FeildName: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fieldName = FeildName;
    }
  }


  OpentoolDetailtbl(data: any, id, event: any) {
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      this.tbldata = data;
      this.tblid = id;
      var FieldsDetails = this.controlAlignArray.find(x => x.step == data.step);
      var getData = FieldsDetails.fields.find(x => x.id === id).fieldJson;

      if (getData != null) {
        this.tblrowsnumber = getData.rows.length;
        this.tblclmnumber = getData.column.length;

        this.LabelName = getData.labelName;
        this.FeildName = "";
      }
    }
  }


  OpentoolDetailText(data: any, id, event: any) {
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      var FieldsDetails = this.controlAlignArray.find(x => x.step == data.step);
      var getData = FieldsDetails.fields.find(x => x.id === id).fieldJson;
      if (getData != null && getData != undefined) {
        //this.text = getData.selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData.isRequired;
        if (getData.isShowListing == null || getData.isShowListing == undefined) {
          this.isShowListing = false;
        } else {
          this.isShowListing = getData.isShowListing;
        }
        if(getData.fieldTypeName=="HtmlEditor")
          {

            this.aiAnswer = getData.selectedValue;
            this.text=getData.aiQuestion
          }
          else
          {
            this.text=getData.selectedValue;
          }
        this.readonly = getData.readonly;
        this.characterlimit = getData.charLimit;
        this.textColor = getData.fontColor;
        var size = getData.fontSize.substr(0, getData.fontSize.length - 2);
        this.fontsize = Number(size);
        this.fontstyle = getData.fontstyle;
        this.fontweight = getData.fontweight;
        this.textdecoration = getData.textdecoration;
        this.fontfamily = getData.fontfamily;
        this.textalign = getData.textalign;
        this.selectedParticipant = getData.selectedParticipant;
        this.buttonText = getData.buttonName;
        this.buttonURL = getData.buttonURL;
        this.acceptOrdeclineText = getData.buttonText;
        this.brushColor = getData.penColor;

        this.LabelName = getData.labelName;
        this.FeildName = "";

        if (this.acceptOrdeclineText == "Approve") {
          this.acceptchecked = true;
          this.declinechecked = false;
        }
        if (this.acceptOrdeclineText == "Decline") {
          this.declinechecked = true;
          this.acceptchecked = false;
        }
        if(getData.fieldTypeName=="Button"){
          this.backgroundColor = getData.backgroundColor;
        }

        if (this.buttonURL != "" && this.buttonURL != undefined && this.buttonURL != '') {
          const url = this.buttonURL;
          window.open(url, '_blank');
        }
        this.controlAlignArray.find(x => x => x.id == id).fields.forEach(element => {
          if (element.id != id)
            element.ShowtoolDetail = false;
        });
      }
    }
  }


  OpentoolDetailDropDown(data: any, id, event: any) {
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      var FieldsDetails = this.controlAlignArray.find(x => x.step == data.step);
      var getData = FieldsDetails.fields.find(x => x.id === id).fieldJson;
      if (getData != null && getData != undefined) {
        if (getData.fieldTypeName == "Dropdown" || getData.fieldTypeName == "MCQ" || getData.fieldTypeName == "TrueFalse" || getData.fieldTypeName == "Rating" || this.SelectedControl == "Feedback") {
          this.dropdownFieldArray = getData.fillList;
        }
        if (getData.fieldID > 0) {
          this.dropdownddisabled = true;
        } else {
          this.dropdownddisabled = false;
        }
        this.text = getData.selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData.isRequired;
        if (getData.isShowListing == null || getData.isShowListing == undefined) {
          this.isShowListing = false;
        } else {
          this.isShowListing = getData.isShowListing;
        }
        this.readonly = getData.readonly;
        this.characterlimit = getData.charLimit;
        this.textColor = getData.fontColor;
        var size = getData.fontSize.substr(0, getData.fontSize.length - 2);
        this.fontsize = Number(size);
        this.fontstyle = getData.fontstyle;
        this.fontweight = getData.fontweight;
        this.textdecoration = getData.textdecoration;
        this.fontfamily = getData.fontfamily;
        this.textalign = getData.textalign;
        this.selectedParticipant = getData.selectedParticipant;

        this.LabelName = getData.labelName;
        this.FeildName = getData.fieldName;
      }
    }
  }


  OpentoolDetailMulDropDown(data: any, id, event: any) {
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
        if (element.id != id)
          element.ShowtoolDetail = false;
      });
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          // if(getData[0].fieldTypeName == "MultiSelect" ){
          //   this.dropdownFieldArray= getData[0].fillList;          
          // }
          if (getData[0].fieldID > 0) {
            this.dropdownddisabled = true;
          } else {
            this.dropdownddisabled = false;
          }
          this.text = getData[0].selectedValue;
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.isRequired = getData[0].isRequired;
          if (getData[0].isShowListing == null || getData[0].isShowListing == undefined) {
            this.isShowListing = false;
          } else {
            this.isShowListing = getData[0].isShowListing;
          }
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
        }
      }
    }
  }



  OpentoolDetailCheckBox(data: any, id, fillListcontrolId: any, event: any) {
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      var FieldsDetails = this.controlAlignArray.find(x => x.step == data.step);
      var getData = FieldsDetails.fields.find(x => x.id === id).fieldJson;
      if (getData != null && getData != undefined) {
        if (getData.fieldTypeName == "Checkbox") {
          this.checkboxFieldArray = getData.fillList;
        }
        if (getData.fieldID > 0) {
          this.checkboxdisabled = true;
        } else {
          this.checkboxdisabled = false;
        }
        this.text = getData.selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.fillListcontrolId = fillListcontrolId;
        this.isRequired = getData.isRequired;
        if (getData.isShowListing == null || getData.isShowListing == undefined) {
          this.isShowListing = false;
        } else {
          this.isShowListing = getData.isShowListing;
        }
        this.readonly = getData.readonly;
        this.characterlimit = getData.charLimit;
        this.textColor = getData.fontColor;
        var size = getData.fontSize.substr(0, getData.fontSize.length - 2);
        this.fontsize = Number(size);
        this.fontstyle = getData.fontstyle;
        this.fontweight = getData.fontweight;
        this.textdecoration = getData.textdecoration;
        this.fontfamily = getData.fontfamily;
        this.textalign = getData.textalign;
        this.selectedParticipant = getData.selectedParticipant;

        this.LabelName = getData.labelName;
        //this.FeildName=event.data.FeildName;
      }
    }
  }


  OpentoolDetailCheckBoxGroup(data: any, id, fillListcontrolId: any, event: any) {
    if (event.target.checked && event.shiftKey || (event.target.checked && this.isClickReplaceEnabled == true)) {
      (document.getElementById(id + fillListcontrolId) as HTMLInputElement).checked = false;
    }
    else if (event.shiftKey || (event.target.checked == false && this.isClickReplaceEnabled == true)) {
      (document.getElementById(id + fillListcontrolId) as HTMLInputElement).checked = true;
    }
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          if (getData[0].fieldTypeName == "CheckBoxGroup") {
            this.checkboxGroupFieldArray = getData[0].fillList;
          }
          if (getData[0].fieldID > 0) {
            this.checkboxdisabled = true;
          } else {
            this.checkboxdisabled = false;
          }
          this.text = getData[0].selectedValue;
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.fillListcontrolId = fillListcontrolId;
          this.isRequired = getData[0].isRequired;
          if (getData[0].isShowListing == null || getData[0].isShowListing == undefined) {
            this.isShowListing = false;
          } else {
            this.isShowListing = getData[0].isShowListing;
          }
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
        }
      }
    }
  }



  onChangedropdownlist(string: any) {
    this.dropdownFieldArray.forEach((element) => {
      var val = string;
    });
    if (this.ControlId != undefined) {
      if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fillList = this.dropdownFieldArray;
      }
    }
  }

  onChangecheckboxlist(string: any) {
    this.checkboxFieldArray.forEach((element) => {
      var val = string;
    });
    if (this.ControlId != undefined) {
      if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
        var FieldsDetails = this.controlAlignArray.find(x => x.step == this.currentStep);
        var getData = FieldsDetails.fields.find(x => x.id === this.ControlId).fieldJson;
        if (getData != null && getData != undefined) {
          var data = getData;
          var objNew = [];
          var obj = {
            id: data.id,
            val: string
          }
        }
        objNew.push(obj);
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fillList = objNew;
      }
    }
  }

  onChangecheckboxGrouplist(string: any, row: any) {
    this.checkboxGroupFieldArray.forEach((element) => {
      var val = string;
    });
    if (this.ControlId != undefined) {
      if (this.imagesWithFields.find(x => x.img == this.ControlData.img) && this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == this.ControlData.img))
        var getData = FieldsDetails.fields.filter(x => x.id === this.ControlId);
      }
    }
  }


  numberOnly(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addValueFielDropDown() {
    this.dropdownFieldAttribute = null;
    let tempObject = Object.assign({}, this.dropdownFieldAttribute);
    this.dropdownFieldArray.push(tempObject);
  }

  addValueFielCheckBox() {
    this.checkboxFieldAttribute = null;
    let tempObject = Object.assign({}, this.checkboxFieldAttribute);
    this.checkboxFieldArray.push(tempObject);
  }

  deleteField(value, row: any) {
    if (value == 'b') {
      const index = this.bulletFieldArray.indexOf(row);
      if (index >= 0) {
        this.bulletFieldArray.splice(index, 1);
      }
    }
    else if (value == 'd') {
      const index = this.dropdownFieldArray.indexOf(row);
      if (index >= 0) {
        this.dropdownFieldArray.splice(index, 1);
      }
    }
    else if (value == 'c') {
      const index = this.checkboxGroupFieldArray.indexOf(row);
      if (index >= 0) {
        this.checkboxGroupFieldArray.splice(index, 1);
      }
    }
    else if (value == 'r') {
      const index = this.radioButtonGroupFieldArray.indexOf(row);
      if (index >= 0) {
        this.radioButtonGroupFieldArray.splice(index, 1);
      }
    }
  }


  onSelectFile(event, data: any, id) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];

        var base64String = reader.result;

        var FileObj = [];
        FileObj.push({
          FullPath: FullPath,
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Base64String: base64String
        });

        if (this.controlAlignArray.find(x => x.step == data.step)) {
          //this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.Lat = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.latitude : '';
          this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.FileData = FileObj
        }

        if (this.dataJson.find(x => x.id == id)) {
          this.dataJson.find(x => x.id == id).FileName = documentName;
          this.dataJson.find(x => x.id == id).FileExtention = documenttype;
          this.dataJson.find(x => x.id == id).value = base64String;
          this.dataJson.find(x => x.id == id).type = 'image';
          this.dataJson.find(x => x.id == id).ctrlType = 'File';
        }
      }
    }
  }

  onSelectImage(event, data: any, id) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];

        var base64String = reader.result;

        var ImageObj = [];
        ImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Imageurl: base64String
        });
        if (this.controlAlignArray.find(x => x.step == data.step)) {
          this.controlAlignArray.find(x => x.step == data.step).fields.find(m => m.id == id).fieldJson.ImageData = ImageObj;
        }

        if (this.dataJson.find(x => x.id == id)) {
          this.dataJson.find(x => x.id == id).value = base64String;
          this.dataJson.find(x => x.id == id).type = 'image';
          this.dataJson.find(x => x.id == id).ctrlType = 'Image';
        }
      }
    }
  }


  signOrInitialTextChanges(e: any) {
    if (this.signName !== '' && this.signName !== undefined) {
      this.SignButtonEnable = true;
      this.InitailButtonEnable = true;
      this.signatureBase64 = '';
      this.signOrInitialImageObj = [];
    } else {
      this.SignButtonEnable = false;
      this.InitailButtonEnable = false;
    }
  }

  radioChangeSign() {
    this.SignButtonEnable = false;
  }

  radioChangeInitails() {
    this.InitailButtonEnable = false;
  }

  setSignInitialFontFamilyChange(e: any) {
    this.signInitialFontFamily = e;
  }


  onSelectSignImage(event, data: any, id: any) {
    data = this.currentSign.data;
    id = this.currentSign.id;
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      this.SignButtonEnable = true;
      this.InitailButtonEnable = true;
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;

        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
        this.filenameForSign = documentName;
        var base64String = reader.result;

        this.signOrInitialImageObj = [];
        this.signOrInitialImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Imageurl: base64String
        });
        this.signatureBase64 = '';
        this.signName = '';
        if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
          this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
          let fillList = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).signatureBase64 = '';
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).signatureText = '';
          this.imagesWithFields = this.imagesWithFields;
        }
      }
    }
  }


  checkBoxRequiredEvent(event) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.isRequired = event.checked == undefined ? '' : event.checked;
    }
  }


  checkBoxShowListingEvent(event) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.isShowListing = event.checked == undefined ? '' : event.checked;
    }

    if (event.checked) {
      if (this.dataJson.find(x => x.id == this.ControlId)) {
        this.dataJson.find(x => x.id == this.ControlId).isShowListing = true;
      }
    } else {
      if (this.dataJson.find(x => x.id == this.ControlId)) {
        this.dataJson.find(x => x.id == this.ControlId).isShowListing = false;
      }
    }
  }

  checkBoxReadOnlyEvent(event) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).readonly = event.checked == undefined ? '' : event.checked;
      this.imagesWithFields = this.imagesWithFields;
    }
  }

  onChangeCharLimit(charLimit: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.charLimit = (charLimit) == undefined ? '' : (charLimit);
    }
  }


  onChangeFontColor(color: any) {
    var data = this.ControlData;
    if (this.hText) {
      if (this.HeaderFooter !== undefined && this.HeaderFooter !== null)
        this.HeaderFooter.find(x => x.type == 'Header').color = color;

    }else
      if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fontColor = color == undefined ? '' : color;
        this.textColor = color;
      }
  }

  onChangeBackgroundColor(color: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.backgroundColor = color == undefined ? '' : color;
      this.backgroundColor = color;
    }

    // if (this.hText) {
    //   if (this.HeaderFooter !== undefined && this.HeaderFooter !== null)
    //     this.HeaderFooter.find(x => x.type == 'Header').color = color;

    // }else
    //   if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
    //     this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fontColor = color == undefined ? '' : color;
    //     this.textColor = color;
    //   }
  }

  onChangeBackgroundColorForm(color: any) {    
    this.backgroundColorForm = color;   
  }

  onBrushColorChange(color: any) {
    this.brushColor = color;
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.penColor = color;
      this.highLightColor = this.hexToRGBA(color, 0.2);
    }
  }



  onChangeTextAlign(textalign: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.textalign = textalign == undefined ? '' : textalign;
      this.textalign = textalign;
    }
  }
  McqRadioChange(e: any, data: any, item: any) {
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.radioSelectedValue = e.value == undefined ? '' : e.value;
      //this.textalign = textalign;
    }

    this.dataJson.find(x => x.id == item.id).value = e.value;
  }

  onChangeTextBoldFont(bold: any) {
    if (this.fontstyle == "bold") {
      bold = "";
    }
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fontstyle = bold == undefined ? '' : bold;
      this.fontstyle = bold;
    }
  }

  onChangeTextItalicFont(italic: any) {
    if (this.fontweight == "italic") {
      italic = "";
    }
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fontweight = italic == undefined ? '' : italic;
      this.fontweight = italic;
    }
  }


  onChangeTextDecoration(textdecoration: any) {
    if (this.textdecoration == "underline" || this.textdecoration == "line-through") {
      textdecoration = "";
    }
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.textdecoration = textdecoration == undefined ? '' : textdecoration;
      this.textdecoration = textdecoration;
    }
  }


  onChangeFontSize(event) {
    var data = this.ControlData;
    var size = event.value + "px";
    this.ControlId;
    if (this.hText) {
      if (this.HeaderFooter !== undefined && this.HeaderFooter !== null){
        this.HeaderFooter.find(x => x.type == 'Header').fontSize = size == undefined ? '' : size;
      }       
    }else{
     if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fontSize = size == undefined ? '' : size;
     }
    }     
  }


  onChangeNumberValue(number: any) {
    var data = this.ControlData;
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.selectedValue = number == undefined ? '' : number;
    }
  }

  onChangeFontFamily(event) {
    var data = this.ControlData;
    var family = event.value;
    this.ControlId;
    if (this.hText) {
      if (this.HeaderFooter !== undefined && this.HeaderFooter !== null){
        this.HeaderFooter.find(x => x.type == 'Header').fontfamily = family == undefined ? '' : family;
      }       
    }else{
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.fontfamily = family == undefined ? '' : family;
      this.fontfamily = family;
    }
   }
  }




  movies = [
    'Episode I - The Phantom Menace',
    'Episode II - Attack of the Clones',
    'Episode III - Revenge of the Sith',
    'Episode IV - A New Hope',
    'Episode V - The Empire Strikes Back',
    'Episode VI - Return of the Jedi',
    'Episode VII - The Force Awakens',
    'Episode VIII - The Last Jedi',
    'Episode IX – The Rise of Skywalker',
  ];

  drops(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.controlAlignArray, event.previousIndex, event.currentIndex);
    for (let index = 0; index < this.controlAlignArray.length; index++) {
      this.controlAlignArray[index].step = index + 1;
    }
    if (this.controlAlignArray.length > 0)
      this.currentPageName = this.controlAlignArray.find(m => m.step == this.currentStep).pageName;
  }

  deleteSelectedControls(data: any, id: any) {
    this.closeDetail();
    if (this.controlAlignArray.find(x => x.step == data.step)) {
      // var index = this.controlAlignArray.findIndex(x => x.id == id);
      // var index = this.controlAlignArray.findIndex(x => x.step == data.step);//.fields.find(m => m.id == id);  
      //  if (index >= 0) {
      this.controlAlignArray.forEach((item) => item.fields.forEach((fields, index) => {
        if (fields.id === id) {
          return item.fields.splice(index, 1);
        }
      }));

      var indexs = this.dataJson.findIndex(x => x.id == id);
      if (indexs >= 0) {
        this.dataJson.splice(indexs, 1);
      }

      if (this.controlAlignArray.length > 0) {
        this.controlAlignArray.map(e => {
          if (e.fields.length > 0) {
            this.SaveButtonDisbled = true;
            return;
          } else {
            this.SaveButtonDisbled = false;
          }
        });
      }

      //  this.controlAlignArray.findIndex(x => x.step == data.step).fields.find(m => m.id == id).splice(index, 1); 
      // this.controlAlignArray.splice(index, 1);
      //  }  
      this.ShowtoolDetail = false;
    }
  }

  deleteSelectedControl() {
    this.closeDetail();
    if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
      // var index = this.controlAlignArray.findIndex(x => x.id == id);
      // var index = this.controlAlignArray.findIndex(x => x.step == data.step);//.fields.find(m => m.id == id);  
      //  if (index >= 0) {
      this.controlAlignArray.forEach((item) => item.fields.forEach((fields, index) => {
        if (fields.id === this.ControlId) {
          return item.fields.splice(index, 1);
        }
      }));

      var indexs = this.dataJson.findIndex(x => x.id == this.ControlId);
      if (indexs >= 0) {
        this.dataJson.splice(indexs, 1);
      }

      if (this.controlAlignArray.length > 0) {
        this.controlAlignArray.map(e => {
          if (e.fields.length > 0) {
            this.SaveButtonDisbled = true;
            return;
          } else {
            this.SaveButtonDisbled = false;
          }
        });
      }
      //  this.controlAlignArray.findIndex(x => x.step == data.step).fields.find(m => m.id == id).splice(index, 1); 
      // this.controlAlignArray.splice(index, 1);
      //  }  
      this.ShowtoolDetail = false;
    }
  }


  showTools() {
    this.showToolsLeft = !this.showToolsLeft
  }

  close() {
    this.SignButtonEnable = false;
    this.DrawButtonEnable = false;
    this.reasonToDecline = "";
    this.declineButtonShow = false;
    this.dialog.closeAll();

    this.savebuttonshow = true;
    this.spinner = false;

    this.activeNode = "";
    this.breadCrumMenu = [];
    this.dataSource.data = [];
  }






  // ==== For Search City/State/Zip === //

  states: string[] = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
    'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
    'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
    'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
    'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
    'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
    'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ];

  cityOption: string[] = [];
  zipOption: any[];
  stateList: any[];
  cityValue: any;
  stateValue: any;
  zipValue: any;

  searchCity(name: any) {
    var ReqModel = {
      databaseID: Number(this.databaseId),
      Name: name,
      userID: this.currentUser.UID
    }
    this.formService.searchTransCities(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.cityOption = [];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }

  getStateDropdownList(countryId: any) {
    if (countryId != undefined) {
      this.formService.getStateList(countryId).subscribe(response => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.stateList = [];
            if (countryId == 231 || countryId == 38) {
              response.data = response.data.filter((x) => x.abbreviation != null);
              response.data.forEach(e => {
                this.stateList.push(e.abbreviation);
              });
            } else {
              response.data.forEach(e => {
                this.stateList.push(e.stateName);
              });
            }
          }
        }
      });
    }
  }


  searchZip(zip: any) {
    var ReqModel = {
      databaseID: Number(this.databaseId),
      ZipCodeValue: zip,
      userID: this.currentUser.UID
    }
    this.formService.searchTransZip(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.zipOption = [];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }



  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    moveItemInArray(this.movies, event.previousIndex, event.currentIndex);

  }





  //================== AddUpdate HTML Form============//

  breadCrumMenu: any = [];
  activeNode: string = "";
  selectedFolderID: number = 0;
  responseHolder: any;
  FormFolderList: any = ([] = []);
  spinner: boolean = false;
  savebuttonshow: boolean = true;



  breadCrumbMyFormsMainClick() {
    this.breadCrumMenu = [];
    this.activeNode = "";
  }


  getFormFolderList() {
    this.selectedFolderID;//=//Number(sessionStorage.getItem('FolderOpenId'));
    this.activeNode = sessionStorage.getItem('FolderOpenName');
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.formService.getFormFolderList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
            if (this.activeNode == "") {
              if (this.dataSource.data.length > 0) {
                var myForm = [];
                myForm = this.dataSource.data.filter(x => x.formFolderName == 'My Forms');
                if (myForm.length > 0) {
                  this.activeNode = myForm[0].formFolderName;
                  this.selectedFolderID = myForm[0].formFolderID;
                  this.breadCrumMenu = [];
                  this.breadCrumMenu.push({ formFolderName: myForm[0].formFolderName, id: myForm[0].formFolderID, icon: 'navigate_next' });
                }
              }
            } else {
              this.breadCrumMenu = [];
              this.breadCrumMenu.push({ formFolderName: sessionStorage.getItem('FolderOpenName'), id: Number(this.selectedFolderID), icon: 'navigate_next' });
            }
          }
        } else {
          this.FormFolderList = [];
        }
      } else {
        this.FormFolderList = [];
      }
    });
  }

  getFormFolderWithFormTemplates(form) {
    this.activeNode = form.formFolderName;
    sessionStorage.setItem('FolderOpenName', form.formFolderName);
    this.selectedFolderID = Number(form.formFolderID);
    var ReqModel = {
      formFolderID: form.formFolderID,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.formService.GetParentFormFolderHierarchy(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.breadCrumMenu = this.responseHolder.data.hierarchy;
        }
        else {
          this.breadCrumMenu = [];
        }
      }
      else {
        this.breadCrumMenu = [];
      }
    });
  }


  GetHtmlForms(HtmlId: any) {
    var ReqModel = {
      formID: Number(HtmlId),
      case:0,// 0-internal, 1-external
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formService.getHtmlForm(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.ResponseHolderDetails = response;
        if (this.ResponseHolderDetails.status == this.statusConstant.statusSuccess) {
          this.selected3cType=this.ResponseHolderDetails.data.selected3cType==1?true:false;
          this.controlAlignArray = JSON.parse(this.ResponseHolderDetails.data.formJson);
          this.backgroundColorForm = this.ResponseHolderDetails.data.formBgColor;
          this.dataJson = JSON.parse(this.ResponseHolderDetails.data.dataJson);
          this.HeaderFooter = JSON.parse(this.ResponseHolderDetails.data.headerFooterJson);
          if (this.HeaderFooter !== undefined && this.HeaderFooter !== null && this.HeaderFooter.length > 0 && this.HeaderFooter.find(x => x.type == 'Header') !== undefined) {
            this.headerText = this.HeaderFooter.find(x => x.type == 'Header').text;
          }
          this.successUrl =this.ResponseHolderDetails.data.successUrl;
          this.declineUrl =this.ResponseHolderDetails.data.declineUrl;
          this.isUrlParameterConfigured=this.ResponseHolderDetails.data.isUrlParameterConfigured;
          this.isConfigureFormParameter=this.ResponseHolderDetails.data.isFolderUrlParameterConfigured;
          if(this.ResponseHolderDetails.data.mapUrlFields!=null){
            this.getmapUrlFields(this.ResponseHolderDetails.data.mapUrlFields);
          }
          if(this.ResponseHolderDetails.data.mapFolderUrlParams.length>0){
            this.getmapFolderUrlParams(this.ResponseHolderDetails.data.mapFolderUrlParams);
          }
          this.currentFormName = this.ResponseHolderDetails.data.formName;
          this.selectedFolderID = this.ResponseHolderDetails.data.formFolderID;
          sessionStorage.setItem('ProjectName', this.ResponseHolderDetails.data.formName);
          if (this.controlAlignArray == null || this.controlAlignArray == undefined) {
            this.controlAlignArray = [];
          }
          if (this.dataJson == null || this.dataJson == undefined) {
            this.dataJson = [];
          }
          this.IsCheckIn=this.ResponseHolderDetails.data.isCheckIn;
          this.currentPageName = this.controlAlignArray.find(m => m.step == 1).pageName;
          var checkHeader = [];
          var checkFooter = [];
          var checkdata = [];
          checkdata = JSON.parse(this.ResponseHolderDetails.data.headerFooterJson);
          if (checkdata != null && checkdata != undefined) {
            checkHeader = checkdata.filter(x => x.type == "Header");
            checkFooter = checkdata.filter(x => x.type == "Footer");
          }
          if (checkHeader.length > 0) {
            this.ShowHeader = true;
          }
          if (checkFooter.length > 0) {
            this.ShowFooter = true;
          }
          this.SaveButtonDisbled = true;
          //  if(this.controlAlignArray.length > 0) {
          //   this.controlAlignArray.map(e => {
          //     if (e.fields.length > 0) {
          //       this.SaveButtonDisbled=true;
          //       return;
          //     }else{
          //       this.SaveButtonDisbled=false;
          //     }
          //   });
          //  } 
          // setTimeout(() => {   
          //   this.loaderService.hide();          
          // },2000);
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  AddHtMLForm() {
    if (this.currentFormName.trim() == "" || this.currentFormName.trim() == null || this.currentFormName.trim() == undefined) {
      this.toastr.error("Please enter form name.", '', {
        timeOut: 3000,
      });
      return;
    }

    // For Add Master Global Template Web Form==///
    if(sessionStorage.getItem('MasterGlobalTemplateWebForm')=="true"){   
      this.AddMasterGlobalWebForm();
      return;
    }
    // For Add Master Template Web Form==///
    if(sessionStorage.getItem('MasterTemplateWebForm')=="true"){
      this.AddMasterOrganizationWebForm();
    }      
   
  }

  AddMasterGlobalWebForm(){
    if(this.MasterTemplatecategoryID==0){
      this.toastr.warning('Please Select Template Category.', '', {
        timeOut: 3000,
      }); 
      return;
    }    

    this.savebuttonshow = false;
    this.spinner = true;
    var ReqModel = {
      formID: 0,
      formName: this.currentFormName,
      formFolderID: this.selectedFolderID,
      formType: FormTypes.HtmlForm,
      formJson: JSON.stringify(this.controlAlignArray),
      dataJson: JSON.stringify(this.dataJson),
      headerFooterJson: JSON.stringify(this.HeaderFooter),
      isCheckIn:this.IsCheckIn,
      templateType: 1,//(Case :To Save Global Level template- (For Superadmin only) -- When Super admin come from master PDF Form link then hide Checkbox on step 4 and pass Templatetype=1)
      templateCategoryID:this.MasterTemplatecategoryID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      IsHTMLFormToggle:(this.selected3cType == true ? 1 : 0) ,
      formBgColor:this.backgroundColorForm   
    }
    // return;
    this.formService.AddHtMLForm(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.toastr.success("HTML form has been saved under the selected folder.", '', {
            timeOut: 3000,
          });
          this.close();
          if (response.data > 0) {           
            this.FormId= response.data;
            this.disableUrlParameterConfigurations();    
            this.disableFolderUrlParameterConfiguration();
            this.manageFormUrlField(response.data);
            this.manageFormFolderUrlParams(response.data);
            this.router.navigate(['/esignature']);
            // this.FormId = response.data;
            // sessionStorage.setItem('HtmlId', response.data);
            // this.GetHtmlForms(response.data);
          }         
        }
        else {
          this.spinner = false;
          this.savebuttonshow = true;
          this.SaveButtonDisbled = false;
          this.toastr.error("Error occurred.", '', {
            timeOut: 3000,
          });
        }
      } else {
        this.spinner = false;
        this.savebuttonshow = true;
        this.SaveButtonDisbled = false;
        this.toastr.error("Error occurred.", '', {
          timeOut: 3000,
        });
      }
    });
  }
  
  

  AddMasterOrganizationWebForm(){
    var templateType=0;
    if(this.showOrganizationTempCategory==true){
      if(this.OrganizationCategoryId==0){
        this.toastr.warning('Please Select Template Category.', '', {
          timeOut: 3000,
        }); 
        return;
      }else{
        templateType=2;
      }

    }else{     
      templateType=0;
    }  

    this.savebuttonshow = false;
    this.spinner = true;
    var ReqModel = {
      formID: 0,
      formName: this.currentFormName,
      formFolderID: this.selectedFolderID,
      formType: FormTypes.HtmlForm,
      formJson: JSON.stringify(this.controlAlignArray),
      dataJson: JSON.stringify(this.dataJson),
      headerFooterJson: JSON.stringify(this.HeaderFooter),
      isCheckIn:this.IsCheckIn,
      templateType: templateType,
      templateCategoryID:templateType==0?0:this.OrganizationCategoryId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      IsHTMLFormToggle:(this.selected3cType == true ? 1 : 0),
      formBgColor:this.backgroundColorForm      
    }
    // return;
    this.formService.AddHtMLForm(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.toastr.success("HTML form has been saved under the selected folder.", '', {
            timeOut: 3000,
          });
          this.close();
          if (response.data > 0) {
            this.FormId= response.data;
            this.disableUrlParameterConfigurations();    
            this.manageFormUrlField(response.data);
            this.manageFormFolderUrlParams(response.data);
            this.router.navigate(['/esignature']);
            // this.FormId = response.data;
            // sessionStorage.setItem('HtmlId', response.data);
            // this.GetHtmlForms(response.data);
          }         
        }
        else {
          this.spinner = false;
          this.savebuttonshow = true;
          this.SaveButtonDisbled = false;
          this.toastr.error("Error occurred.", '', {
            timeOut: 3000,
          });
        }
      } else {
        this.spinner = false;
        this.savebuttonshow = true;
        this.SaveButtonDisbled = false;
        this.toastr.error("Error occurred.", '', {
          timeOut: 3000,
        });
      }
    });
  }

  UpdateHtMLForm() {
    if (this.currentFormName.trim() == "" || this.currentFormName.trim() == null || this.currentFormName.trim() == undefined) {
      this.toastr.error("Please enter form name.", '', {
        timeOut: 3000,
      });
      return;
    }

    // For Edit Organization Template Web Form
    if(sessionStorage.getItem('MasterOrgTemplateWebForm')=="true"){
     this.UpdateMasterTemplateWebFormEdit("Finish");
     return;
    }

    if(sessionStorage.getItem('MasterGlobalTemplateWebForm')=="true"){   
      this.UpdateMasterGlobalWebForm("Finish");
      return;
    }
    if(sessionStorage.getItem('MasterGlobalTemplateWebForm')=="false"){   
      this.UpdateMasterTemplateWebForm("Finish");
      return;
    }     
  }

  UpdateHtMLFormFromSave() {
    if (this.currentFormName.trim() == "" || this.currentFormName.trim() == null || this.currentFormName.trim() == undefined) {
      this.toastr.error("Please enter form name.", '', {
        timeOut: 3000,
      });
      return;
    }
    this.loaderService.show();
    this.spinner = true;
    this.savebuttonshow = false;
    //this.spinner = true;
    // For Edit Organization Template Web Form
    if(sessionStorage.getItem('MasterOrgTemplateWebForm')=="true"){
     this.UpdateMasterTemplateWebFormEdit("Save");
     return;
    }
    if(sessionStorage.getItem('MasterGlobalTemplateWebForm')=="true"){   
      this.UpdateMasterGlobalWebForm("Save");
      return;
    }
    if(sessionStorage.getItem('MasterGlobalTemplateWebForm')=="false"){   
      this.UpdateMasterTemplateWebForm("Save");
      return;
    }
  }

  UpdateMasterTemplateWebFormEdit(type){
    var templateType=0;
    if(this.OrganizationCategoryId==0){
      this.toastr.warning('Please Select Template Category.', '', {
        timeOut: 3000,
      }); 
      return;
    }else{
      templateType=2;
    }
    this.savebuttonshow = false;
    this.spinner = true;
    var ReqModel = {
      formID: this.FormId,
      formName: this.currentFormName,
      formFolderID: this.selectedFolderID,
      formJson: JSON.stringify(this.controlAlignArray),
      dataJson: JSON.stringify(this.dataJson),
      headerFooterJson: JSON.stringify(this.HeaderFooter),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      isCheckIn:this.IsCheckIn,
      templateType: this.templateType,
      templateCategoryID:templateType==0?0:this.OrganizationCategoryId,
      IsHTMLFormToggle:(this.selected3cType == true ? 1 : 0),
      formBgColor:this.backgroundColorForm  
    }
    // return;
    this.formService.UpdateHTMLForm(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.toastr.success("HTML form update successfully.", '', {
            timeOut: 3000,
          });
          if(type=="Finish"){
            this.router.navigate(['/esignature']);
            this.close(); 
          }
        this.loaderService.hide();
        this.spinner = false;
        this.savebuttonshow = true;
        }
        else {
          this.spinner = false;
          this.savebuttonshow = true;
          this.toastr.error("Error occurred.", '', {
            timeOut: 3000,
          });
        }
      } else {
        this.spinner = false;
        this.savebuttonshow = true;
        this.toastr.error("Error occurred.", '', {
          timeOut: 3000,
        });
      }
    });
  }

  UpdateMasterTemplateWebForm(type){
    var templateType=0;
    if(this.showOrganizationTempCategory==true){
      if(this.OrganizationCategoryId==0){
        this.toastr.warning('Please Select Template Category.', '', {
          timeOut: 3000,
        }); 
        return;
      }else{
        templateType=2;
      }

    }else{     
      templateType=0;
    } 
    this.savebuttonshow = false;
    this.spinner = true;
    var ReqModel = {
      formID: this.FormId,
      formName: this.currentFormName,
      formFolderID: this.selectedFolderID,
      formJson: JSON.stringify(this.controlAlignArray),
      dataJson: JSON.stringify(this.dataJson),
      headerFooterJson: JSON.stringify(this.HeaderFooter),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      isCheckIn:this.IsCheckIn,
      templateType: templateType,
      templateCategoryID:templateType==0?0:this.OrganizationCategoryId,
      IsHTMLFormToggle:(this.selected3cType == true ? 1 : 0),
      formBgColor:this.backgroundColorForm  
    }
    // return;
    this.formService.UpdateHTMLForm(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.toastr.success("HTML form update successfully.", '', {
            timeOut: 3000,
          });
          if(type=="Finish"){
            this.router.navigate(['/esignature']);
            this.close(); 
          }
          this.loaderService.hide();     
          this.spinner = false;  
          this.savebuttonshow = true;     
        }
        else {
          this.spinner = false;
          this.savebuttonshow = true;
          this.toastr.error("Error occurred.", '', {
            timeOut: 3000,
          });
        }
      } else {
        this.spinner = false;
        this.savebuttonshow = true;
        this.toastr.error("Error occurred.", '', {
          timeOut: 3000,
        });
      }
    });
  }


  UpdateMasterGlobalWebForm(type){
    if(this.MasterTemplatecategoryID==0){
      this.toastr.warning('Please Select Template Category.', '', {
        timeOut: 3000,
      }); 
      return;
    }  

    this.savebuttonshow = false;
    this.spinner = true;
    var ReqModel = {
      formID: this.FormId,
      formName: this.currentFormName,
      formFolderID: this.selectedFolderID,
      formJson: JSON.stringify(this.controlAlignArray),
      dataJson: JSON.stringify(this.dataJson),
      headerFooterJson: JSON.stringify(this.HeaderFooter),      
      templateType: 1,//(Case :To Save Global Level template- (For Superadmin only) -- When Super admin come from master PDF Form link then hide Checkbox on step 4 and pass Templatetype=1)
      templateCategoryID:this.MasterTemplatecategoryID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList, 
      IsHTMLFormToggle:(this.selected3cType == true ? 1 : 0),
      formBgColor:this.backgroundColorForm   
    }
    // return;
    this.formService.UpdateHTMLForm(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.toastr.success("HTML form update successfully.", '', {
            timeOut: 3000,
          });
          if(type=="Finish"){
            this.router.navigate(['/esignature']);
            this.close(); 
          }
        this.loaderService.hide();     
        this.spinner = false;  
        this.savebuttonshow = true; 
        }
        else {
          this.loaderService.hide(); 
          this.spinner = false;
          this.savebuttonshow = true;
          this.toastr.error("Error occurred.", '', {
            timeOut: 3000,
          });
        }
      } else {
        this.spinner = false;
        this.savebuttonshow = true;
        this.toastr.error("Error occurred.", '', {
          timeOut: 3000,
        });
      }
    });
  }

  //================== ============//


  ShowHeader: boolean = false;
  ShowFooter: boolean = false;
  IsCheckIn: boolean = false;
  HeaderFooter: any = [] = [];
  headerText: any = "";

  onSelectImageForHeaderFooter(event, type) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];

        var base64String = reader.result;

        var ImageObj = [];
        ImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Imageurl: base64String
        });
        if (this.HeaderFooter.find(x => x.type == type)) {
          this.HeaderFooter.find(x => x.type == type).ImageData = ImageObj;
        }
      }
    }
  }

  addHeaderText(event: any) {
    this.HeaderFooter.find(x => x.type == 'Header').text = event.target.value;
    this.savebuttonshow = true;
    this.SaveButtonDisbled = true;
  }

  showHeader(event: MatCheckboxChange): void {
    if (event.checked == true) {
      if (this.HeaderFooter == null || this.HeaderFooter == undefined) {
        this.HeaderFooter = [];
      }
      this.HeaderFooter.push({
        type: 'Header',
        ImageData: [],
        text: "",
        color: "rgb(13, 12, 13)",
        fontFamily: "",
        fontSize: ""
      });
    } else {
      var indexs = this.HeaderFooter.findIndex(x => x.type == 'Header');
      if (indexs >= 0) {
        this.HeaderFooter.splice(indexs, 1);
      }
    }
    this.ShowHeader = event.checked;
    this.savebuttonshow = true;
    this.SaveButtonDisbled = true;
  }

  showFooter(event: MatCheckboxChange): void {
    if (event.checked == true) {
      if (this.HeaderFooter == null || this.HeaderFooter == undefined) {
        this.HeaderFooter = [];
      }
      this.HeaderFooter.push({
        type: 'Footer',
        ImageData: [],
      });
    } else {
      var indexs = this.HeaderFooter.findIndex(x => x.type == 'Footer');
      if (indexs >= 0) {
        this.HeaderFooter.splice(indexs, 1);
      }
    }
    this.ShowFooter = event.checked;
    this.savebuttonshow = true;
    this.SaveButtonDisbled = true;
  }

  checkIn(event: MatCheckboxChange): void {
    this.IsCheckIn = event.checked;
    this.savebuttonshow = true;
    this.SaveButtonDisbled = true;
  }

  GetMultiSelectConvertedValue(val, item, multiVal) {
    if (multiVal != "" && !Array.isArray(multiVal) && multiVal != undefined && multiVal.split(',').length > 0) {
      multiVal = multiVal.split(',');
      multiVal.push(val);
    }
    else if ((multiVal == "" || multiVal == undefined) && !Array.isArray(multiVal)) {
      multiVal = []
      multiVal.push(val);
    }
    else if (multiVal != "" && Array.isArray(multiVal) && multiVal != undefined) {
      multiVal.push(val);
    }
    else if (multiVal == "" && Array.isArray(multiVal) && multiVal != undefined) {
      multiVal.push(val);
    }
    return multiVal;

  }

  RemoveMultiSelectConvertedValue(val, item, multiVal) {
    if (multiVal != "" && !Array.isArray(multiVal) && multiVal != undefined && multiVal.split(',').length > 0) {
      multiVal = multiVal.split(',');
      multiVal = multiVal.filter(m => m != val)
    }
    else if (multiVal != "" && Array.isArray(multiVal) && multiVal != undefined) {
      multiVal = multiVal.filter(m => m != val)
    }
    return multiVal;
  }

  AddMultiSelectItem(val, item) {
    let multiVal = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue

    this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue = this.GetMultiSelectConvertedValue(val, item, multiVal);
    this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList.filter(m => m.val != val);
    this.imagesWithFields = JSON.parse(JSON.stringify(this.imagesWithFields));
    this.multiSelectCurrentItem = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id);
    // auto fill other jsons and save
    this.participantArray.forEach(ml => {
      let jsonelement: any;
      if (this.selectedDocumentId === ml.documentId) {
        jsonelement = JSON.parse(ml.participantJson);

        if (jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id) != undefined) {
          let multiValjson = jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue
          jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue = this.GetMultiSelectConvertedValue(val, item, multiValjson);
          jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList = jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList.filter(m => m.val != val);

          ml.participantJson = JSON.stringify(jsonelement);
        }
      }
    });
  }

  removeMultiSelectItem(val, item) {
    let multiVal = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue;
    this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue = this.RemoveMultiSelectConvertedValue(val, item, multiVal);
    this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList.push({
      "id": "ctrl-0",
      "val": val,
      "offsetX": 573,
      "offsetY": 387
    });
    this.multiSelectCurrentItem = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id);
    // auto fill other jsons and save
    this.participantArray.forEach(ml => {
      let jsonelement: any;
      if (this.selectedDocumentId === ml.documentId) {
        jsonelement = JSON.parse(ml.participantJson);
        if (jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id) != undefined) {
          let multiValjson = jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue;
          jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue = this.RemoveMultiSelectConvertedValue(val, item, multiValjson);
          jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList.push({
            "id": "ctrl-0",
            "val": val,
            "offsetX": 573,
            "offsetY": 387
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
      }
    });
  }

  keyPress(event) {
    this.declineButtonShow = true;
  }


  closeDetail() {
    this.ShowtoolDetail = !this.ShowtoolDetail;
    this.openInDevice = false;
    this.breadCrumMenu = [];
    this.activeNode = "";
  }


  onResized(event: ResizedEvent, step: any, item: any) {
    this.width = event.newWidth;
    this.height = event.newHeight;

    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetHeight = event.newHeight;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetWidth = event.newWidth;
  }

  onResizeStop(event, step: any, item: any) {
    //this.offsetHeight =  event.newHeight;
    // this.offsetWidth = event.newWidth;

    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetHeight = event.size.height;
    this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).fieldJson.offsetWidth = event.size.width;

  }

  onResized1(event: ResizedEvent) {
    this.ImgWidth = event.newWidth;
    this.width = event.newWidth / 750;
    this.height = event.newHeight;

  }

  peoples = [
    {
      name: 'Katina',
      email: 'Katina@gmail.com',
      img: 'Katina.jpg',
      role: 'Buyer'
    },
    {
      name: 'joyce',
      email: 'joyce@gmail.com',
      img: 'joyce.jpg',
      role: 'Doctor'
    },
    {
      name: 'Christy',
      email: 'Christy@gmail.com',
      img: 'Christy.jpg',
      role: 'Patient'
    },
    {
      name: 'garry',
      email: 'garry@gmail.com',
      img: 'garry.jpg',
      role: 'Nurse'
    },
    {
      name: 'Barrera',
      email: 'Barrera@gmail.com',
      img: 'Barrera.jpg',
      role: 'Employee'
    },
  ]

  setWidth(step: any, item: any) {

    const currentWidthVallue = this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).IsFullWidth

    if (currentWidthVallue == "fullWidth") {
      this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).IsFullWidth = "twoThird";
    }
    if (currentWidthVallue == "twoThird") {
      this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).IsFullWidth = "halfWidth";
    }
    if (currentWidthVallue == "halfWidth") {
      this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).IsFullWidth = "oneThird";
    }
    if (currentWidthVallue == "oneThird") {
      this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).IsFullWidth = "fullWidth";
    }
  }

  centerBlock(step: any, item: any) {

    const currentalignVallue = this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).alignBlock

    if (currentalignVallue == "alignBlockleft") {
      this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).alignBlock = "alignBlockcenter";
    }
    if (currentalignVallue == "alignBlockcenter") {
      this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).alignBlock = "alignBlockright";
    }
    if (currentalignVallue == "alignBlockright") {
      this.controlAlignArray.find(x => x.step == step.step).fields.find(m => m.id == item.id).alignBlock = "alignBlockleft";
    }

    this.ControlData = step;
    this.ControlId = step.id;
  }

  getClass(className: any) {
    return `${className.IsFullWidth} ${className.alignBlock}`
  }







  showOrgnizationLevelCheckbox:boolean=false;
  templateType:number=0;
  isSendEnabled:boolean = true;
  templateName:string="";
  OrganizationLeveltemplateList: any[] = [];
  showFormFolder:boolean=true;
  OrganizationCategoryId:number=0;
  showOrganizationTempCategory:boolean=false;
  MasterTemplateGlobalWebForm:boolean=false;
  CategoryTypeList:any[]=[];
  MasterTemplatecategoryID:number=0;
  SaveTemplateButton:boolean=false;
  MasterOrgTemplateWebFormEdit:boolean=false;
  MasterTemplateWebFormAdd:boolean=false;

  OpenPopUpForFolder(templateRef: TemplateRef<any>) {
    if (this.currentFormName.trim() == "" || this.currentFormName.trim() == null || this.currentFormName.trim() == undefined) {
      this.toastr.error("Please enter form name.", '', {
        timeOut: 3000,
      });
      return;
    }
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup'
    });
    this.getFormFolderList();
    this.showFormFolder=true;  
    this.showOrganizationTempCategory=false;

    // For Edit Organization Template Web Form
    if(sessionStorage.getItem('MasterOrgTemplateWebForm')=="true"){
      var categoryID= sessionStorage.getItem('categoryID');
      if(categoryID!=null && categoryID!=undefined){
        this.getOrganizationFormTemplateGallery();
        this.OrganizationCategoryId=Number(categoryID);
        this.MasterOrgTemplateWebFormEdit=true;
        //this.showFormFolder=true;
        this.MasterTemplateGlobalWebForm=false;
        sessionStorage.setItem('FolderOpenName',"");
      }
      return;
    }
    
    // For Add Organization Template Web Form
    if(sessionStorage.getItem('MasterTemplateWebForm')=="true"){
     this.isSendEnabled=true;
     this.MasterTemplateWebFormAdd=true;
     this.showOrganizationTempCategory=true;
     this.MasterOrgTemplateWebFormEdit=false;
     this.showOrganizationTempCategory=false;
     this.getCategoryTypeList();
     return;
    }

    if(sessionStorage.getItem('MasterGlobalTemplateWebForm')=="true"){   
      var categoryID= sessionStorage.getItem('categoryID');
      if(categoryID!=null && categoryID!=undefined){        
        this.MasterTemplatecategoryID=Number(categoryID);     
      }
        this.getCategoryTypeList();
        this.MasterTemplateGlobalWebForm=true;
        this.MasterTemplateWebFormAdd=false;
        this.MasterOrgTemplateWebFormEdit=false;
        this.showOrganizationTempCategory=false;
        this.showFormFolder=false;              
     }    
    
  }

   // get category list //
   getCategoryTypeList() {
    var ReqModel={
      isCategoriesOnly: true
   }
    this.formService.GetMasterTemplateCategoryList(ReqModel).subscribe(response => {
    if (response != undefined) {
     this.responseHolder = response;
     if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
      this.CategoryTypeList = this.responseHolder.data.categories.filter(x => x.isActive == true);
     }
      else {
     }
    }
   });
   }

   SelectCategoryType(event){
    this.MasterTemplatecategoryID= event.value;
    this.SaveTemplateButton=false;
  }

  getOrganizationFormTemplateGallery(){
    var rqModel={
     isCategoriesOnly:true,
     isAllTemplate:true,
     categoryID:0,
     templateType: 2, //0 self,  3 office, 2 organization, 1 super admin
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),
     databaseID: Number(this.databaseId),
     officeIDList:this.OfficeIDList,
     officeID:this.myOfficeID,     
    }
     this.formService.getOrganizationFormTemplateGallery(rqModel).subscribe(response => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
           if(this.responseHolder.data!=null){
            this.OrganizationLeveltemplateList = this.responseHolder.data.categories.filter(x => x.isActive == true);         
             } 
          }
        }
     });
   }

   //For  Open Pop (Add Category) //Save as Organization Template
   AddOrgTemCatDialog() {
      const dialogRef = this.dialog.open(AddOrgTempCategoryComponent, {     
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result!=null && result!=undefined){
         this.getOrganizationFormTemplateGallery(); 
        }    
      });
   }
   
    openDialogForAddCategory() {
    const dialogRef = this.dialog.open(AddMasterTempCategoryComponent, {     
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
       this.getCategoryTypeList(); 
      }    
    });
  }


   SelectOrganizationCategoryType(event){
     this.OrganizationCategoryId= event.value;
   }
    
  OnSelectaboutSaveTemplate1(value:any) {
    //Save Template Only
    if(value=="1"){     
     this.showFormFolder=true;  
     this.showOrganizationTempCategory=false;  
    }   
    if(value=="2"){     
      this.showFormFolder=false;
      this.showOrganizationTempCategory=true;
      this.getOrganizationFormTemplateGallery();
    } 
   }



   //=============== 3rd Party Url Accept Configuration ==============//

   folderId:number=0;
   coreFieldList:any=[]=[];
   coreDropdownList:any=[]=[];
   isUrlParameterConfigured: boolean = false;
   dynamicForm: FormGroup;
   dynamicFormParameter: FormGroup;
   successUrl:string="";
   declineUrl:string="";

   showSuccessUrlMessage:boolean=false;
   showDeclineUrlMessage:boolean=false;
   show3rdPartyurl:boolean=false;

   Open3rdPartyURL(templateRef: TemplateRef<any>){
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
   }

   OpenConfigureFormSelection(templateRef: TemplateRef<any>){
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
   }

   onSuccessURLChange(searchValue: string): void {  
    if(searchValue==""){
      this.showSuccessUrlMessage=false;
    }
    if(searchValue!=""){
     var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
     if(!regex.test(searchValue)) {
      this.showSuccessUrlMessage=true;
     }else{
      this.showSuccessUrlMessage=false;
     }
    }
  }

  onDeclineURLChange(searchValue: string): void {  
    if(searchValue==""){
      this.showDeclineUrlMessage=false;
    }
    if(searchValue!=""){
     var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
     if(!regex.test(searchValue)) {
      this.showDeclineUrlMessage=true;
     }else{
      this.showDeclineUrlMessage=false;
     }
    }
  }

  getmapUrlFields(mapUrlFields: any) {   
    if (mapUrlFields.length > 0) {
      mapUrlFields.forEach(seedDatum => {
        const formGroup = this.createFilterGroup();
        if (seedDatum) {
          formGroup.addControl('fieldID', this.getFormControl());
          formGroup.addControl('parameterName', this.getFormControl());         
        }
        formGroup.patchValue(seedDatum);
        this.filtersFormArray.push(formGroup);
      });
    }
  }

  getmapFolderUrlParams(mapFolderUrlParams: any) {   
    if (mapFolderUrlParams.length > 0) {
       mapFolderUrlParams.forEach(seedDatum => {
        const formGroup = this.createFormParameterFilterGroup();
        if (seedDatum) {
          formGroup.addControl('parameterID', this.getFormControl());
          formGroup.addControl('parameterName', this.getFormControl());  
          formGroup.addControl('value', this.getFormControl());         
        }
        formGroup.patchValue(seedDatum);
        this.filtersFormParameterArray.push(formGroup);      
      });
    }
  }

  get filtersFormArray() {
    return (<FormArray>this.dynamicForm.get('filters'));
  }
  
  get filtersFormParameterArray() {
    return (<FormArray>this.dynamicFormParameter.get('filtersFormParameter'));
  }

  createFilterGroup() {
    return this.formBuilder.group({     
     fieldID:0,
     parameterName: '',
    });
  }
  
  createFormParameterFilterGroup() {
    return this.formBuilder.group({  
     parameterID:0,       
     parameterName: '',
     value: ''
    });
  }

  getFormControl() {
    return this.formBuilder.control(null);
  }

  removeFilterFromFiltersFormArray(index, filter: any) {   
    this.filtersFormArray.removeAt(index);
  }

  removeFormParameterFromFiltersFormArray(index, filter: any) {   
    this.filtersFormParameterArray.removeAt(index);
  }
  

  addFilterToFiltersFormArray() {
    this.filtersFormArray.push(this.createFilterGroup());
  }

   addFormParameterFiltersFormArray() {
    this.filtersFormParameterArray.push(this.createFormParameterFilterGroup());
  }

  change3rdPartyurl(event: any) {
    if(event.checked==true){
      this.isUrlParameterConfigured=true;
     }
     if(event.checked==false){
      this.isUrlParameterConfigured=false;
     }

   if(this.FormId>0){
    if(event.checked==true){
      this.isUrlParameterConfigured=true;
     }
     if(event.checked==false){
      this.isUrlParameterConfigured=false;
     }
       
      var reqModel={
        flag:this.isUrlParameterConfigured,
        itemID:Number(this.FormId),
        itemType:0,      
        userID : this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),        
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList     
      } 
      this.formService.disableUrlParameterConfiguration(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
           
          }
        }
      });
    }
   
  }

  changeFormSelectionParameter(event: any) {
    if(event.checked==true){
      this.isConfigureFormParameter=true;
     }
     if(event.checked==false){
      this.isConfigureFormParameter=false;
     }

   if(this.FormId>0){
    if(event.checked==true){
      this.isConfigureFormParameter=true;
     }
     if(event.checked==false){
      this.isConfigureFormParameter=false;
     }
       
      var reqModel={
        flag:this.isConfigureFormParameter,
        itemID:Number(this.FormId),
        itemType:0,      
        userID : this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),        
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList     
      } 
      this.formService.disableFolderUrlParameterConfiguration(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
           
          }
        }
      });
    }
   
  }

  disableUrlParameterConfigurations(){
    var reqModel={
      flag:this.isUrlParameterConfigured,
      itemID:Number(this.FormId),
      itemType:0,      
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),        
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList     
    } 
    this.formService.disableUrlParameterConfiguration(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
         
        }
      }
    });
  }

  disableFolderUrlParameterConfiguration(){
    var reqModel={
      flag:this.isConfigureFormParameter,
      itemID:Number(this.FormId),
      itemType:0,      
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),        
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList     
    } 
    this.formService.disableFolderUrlParameterConfiguration(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
         
        }
      }
    });
  }

    // get all core Feilds
    getAllFolderFields() {   
      var reqModel={
        userID : this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),     
        folderID : this.folderId,//17;
        subFolderID: 0,
        fieldID: 0,
        requestFrom: 0,
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList
      } 
      this.formService.getCoreFeildList(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this.coreFieldList = response.data.activeFields.filter((m) => m.fieldID > 0);           
            this.coreDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');            
          }
        }
      });
    }

    manageFormUrlField(Id){  
      if(this.successUrl==null){
        this.successUrl="";
      }
      if(this.declineUrl==null){
        this.declineUrl="";
      }
      if(this.successUrl!="" || this.declineUrl!=""){
         var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
         if(this.successUrl!=""){
          if(!regex.test(this.successUrl)) {
            this.showSuccessUrlMessage=true;
            return;
           }else{
            this.showSuccessUrlMessage=false;
           }
         }
         
         if(this.declineUrl!=""){
          if(!regex.test(this.declineUrl)) {
            this.showDeclineUrlMessage=true;
            return;
           }else{
            this.showDeclineUrlMessage=false;
           }
         }           
      }
  
      var mapUrlFields:any=[]=[];
  
      if(this.showSuccessUrlMessage==false && this.showSuccessUrlMessage==false){
        if(this.filtersFormArray.value.length>0){
          for (let i = 0; i < this.filtersFormArray.value.length; i++){
            if(this.filtersFormArray.value[i].fieldID!=0 && this.filtersFormArray.value[i].parameterName==""){
              this.toastr.warning('Please enter parameter name .', '', {
                timeOut: 3000,
              }); 
              return;
            }
          }
        }
  
        if(this.filtersFormArray.value.length>0){
          this.filtersFormArray.controls.forEach(ee1 => {
            if(ee1.value.fieldID!=0){
              mapUrlFields.push({
                "fieldID":ee1.value.fieldID,
                "parameterName":ee1.value.parameterName,
               });
            }      
         });
      
        } 
        
           
      }
     
      if(this.successUrl=="" && this.declineUrl=="" && mapUrlFields.length==0){
        return;
      }else{
        var reqModel={
          mapUrlFields:mapUrlFields,
          successUrl:this.successUrl,
          declineUrl:this.declineUrl,
          formID:Number(Id),
          userID : this.currentUser.UID,
          organizationID: Number(this.organizationId),
          databaseID: Number(this.databaseId),        
          officeID:this.myOfficeID,
          OfficeIDList:this.OfficeIDList,
          isUrlParameterConfigured:this.isUrlParameterConfigured
        } 
        this.formService.manageFormUrlFields(reqModel).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
             
            }
          }
        });
      }
  
    }

    isConfigureFormParameter:boolean=false;

   manageFormFolderUrlParams(Id){        
    var mapUrlParamsList:any=[]=[];
    if(this.filtersFormParameterArray.value.length>0){
     // if(this.filtersFormParameterArray.value.length>0){
     //   for (let i = 0; i < this.filtersFormArray.value.length; i++){
     //     if(this.filtersFormArray.value[i].fieldID!=0 && this.filtersFormArray.value[i].parameterName==""){
     //       this.toastr.warning('Please add enter parameter name .', '', {
     //         timeOut: 3000,
     //       }); 
     //       return;
     //     }
     //   }
     // }

     if(this.filtersFormParameterArray.value.length>0){
      this.filtersFormParameterArray.controls.forEach(ee1 => {
        if(ee1.value.value!='' && ee1.value.parameterName!=''){
          mapUrlParamsList.push({
           "parameterID":ee1.value.parameterID,
           "value":ee1.value.value,
           "parameterName":ee1.value.parameterName,
           });
        }      
     });
  
    }
           
  
   var reqModel={
     mapUrlParams:mapUrlParamsList,     
     formID:Number(Id),
     userID : this.currentUser.UID,
     organizationID: Number(this.organizationId),
     databaseID: Number(this.databaseId),        
     officeID:this.myOfficeID,
     OfficeIDList:this.OfficeIDList,
     isFolderUrlParameterConfigured:this.isConfigureFormParameter
   } 
   this.formService.manageFormFolderUrlParams(reqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
        
       }
     }
     });
    }  
     
  }


    UpdateURL(){
      if(this.FormId>0 && this.isUrlParameterConfigured==false){
        this.disableUrlParameterConfigurations();
        this.close();
      }
      if(this.FormId>0 && this.isUrlParameterConfigured==true){
        this.disableUrlParameterConfigurations();
        this.manageFormUrlField(this.FormId);
        this.close();
      }
      
    }

    UpdateConfigureForm(){
      if(this.FormId>0 && this.isConfigureFormParameter==false){
        this.disableFolderUrlParameterConfiguration();
        this.close();
      }
      if(this.FormId>0 && this.isConfigureFormParameter==true){
        this.disableFolderUrlParameterConfiguration();
        this.manageFormFolderUrlParams(this.FormId);
        this.close();
      }     
    }

    topMargin = undefined;

    onChangeSpaceMarginSize($event){
      
      var data = this.ControlData;
      if (this.controlAlignArray.find(x => x.step == this.currentStep)) {
        this.controlAlignArray.find(x => x.step == this.currentStep).fields.find(m => m.id == this.ControlId).fieldJson.topMargin = this.topMargin === undefined ? "10px" : $event.value + 'px';
        this.topMargin = $event.value + 'px';
      }
    }

}

interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}